<template>
  <v-container fluid class="pa-0">
    <v-card class="mx-auto" max-width="1200" elevation="2">
      <v-app-bar flat dense color="primary" dark>
        <v-toolbar-title class="text-h6 font-weight-bold">
          {{ formTitle }} {{ invoice_number }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>

      <v-card-text class="pa-1">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" md="4">
              <v-card outlined class="mb-4">
                <v-card-title class="subtitle-1">
                  <v-icon left color="primary">mdi-office-building</v-icon>
                  Información de Negocio
                </v-card-title>
                <v-card-text>
                  <v-autocomplete v-model="filters.business" :items="itemsBussines" label="Unidad de negocio"
                    :disabled="type === 3 || type === 4" :readonly="disableInput" @change="loadLogo" return-object dense
                    outlined hide-details="auto" prepend-inner-icon="mdi-domain"
                    :rules="[(v) => !!v || 'Unidad de negocio es requerida']" required></v-autocomplete>
                  <v-autocomplete v-model="filters.location" :items="filters.business != null
                    ? itemsLocations.filter(
                      (element) => element.bus_id == filters.business.value
                    )
                    : []
                    " label="Location" :disabled="type === 3 || (type === 4 && filters.location != null)"
                    :readonly="disableInput" @change="updateWarehouse" dense outlined hide-details="auto"
                    prepend-inner-icon="mdi-map-marker" :rules="[(v) => !!v || 'Location es requerida']" required
                    return-object class="mt-4"></v-autocomplete>
                  <v-autocomplete v-model="filters.department_id" :items="itemsDepartments" label="Departamento"
                    :disabled="type === 3 || type === 4" :readonly="disableInput" dense outlined hide-details="auto"
                    prepend-inner-icon="mdi-office-building" required class="mt-4"></v-autocomplete>

                  <SearchReceptions class="" v-if="type === 1" :filters="filters"
                    @selected-item="viewReceptions($event)" />
                  <SearchInvoice v-if="type === 3 || type === 4" @selected-item="viewInvoiceSelected($event)"
                    :type="type" @showSearch="dialogSearchInvoice = true" @hideSearch="dialogSearchInvoice = false"
                    :type_invoice="type_invoice" :dialogSearchInvoice="dialogSearchInvoice" />

                  <v-card v-if="(type === 3 || type === 4) && selected_invoices && selected_invoices.invoice_id"
                    outlined class="mt-4">
                    <v-card-title class="subtitle-2">
                      <v-icon left color="primary">mdi-file-document</v-icon>
                      Factura base seleccionada
                    </v-card-title>
                    <v-card-text class="pt-0">
                      <v-row>
                        <v-col cols="12">
                          <div class="text-subtitle-2">{{ selected_invoices.invoice_number }}</div>
                          <div class="text-body-2">{{ selected_invoices.entity_name }}</div>
                        </v-col>
                        <v-col cols="12" class="d-flex align-center flex-wrap">
                          <v-chip :color="noteBaseIsElectronic ? 'success' : 'grey'" small label class="mr-2"
                            text-color="white">
                            {{ noteBaseIsElectronic ? 'eCF (E...)' : 'No eCF' }}
                          </v-chip>
                          <span class="text-body-2 mr-4">
                            Comprobante: <strong>{{ noteBaseVoucher || '-' }}</strong>
                          </span>
                          <v-chip
                            v-if="selected_invoices.available_total != null"
                            :color="selected_invoices.available_total <= 0 ? 'error' : selected_invoices.available_total < selected_invoices.total_amount ? 'warning' : 'success'"
                            small label text-color="white">
                            Disponible: {{ parseFloat(selected_invoices.available_total || 0).toFixed(2) }}
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <v-alert v-if="noteExceedsOriginal" type="error" dense outlined class="mt-2">
                    El total de la nota ({{ parseFloat(totales.total_amount || 0).toFixed(2) }}) excede el saldo disponible en la factura base ({{ parseFloat(selected_invoices.available_total || 0).toFixed(2) }}). Reduzca las cantidades o montos.
                  </v-alert>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="4">
              <v-card outlined class="mb-4">
                <v-card-title class="subtitle-1 pb-0">
                  <v-spacer></v-spacer>
                  <v-icon left color="primary">mdi-currency-usd</v-icon>
                  Moneda
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text>
                  <v-row justify="center" align="center" class="my-1" v-show="manual_currency_rate == null">
                    <span> Tasa: {{ rate_info.value }} | Fecha: {{ rate_info.effective_date }}</span>
                  </v-row>
                  <v-btn-toggle v-model="seleted_currencies" mandatory color="primary"
                    class="d-flex justify-center mb-4 mx-1" :rules="[(v) => !!v || 'Moneda es requerida']">
                    <v-btn v-for="(item, i) in currencies" :key="i" :value="item.id" :disabled="in_invoice_id != null ||
                      type == 3 ||
                      type == 4 ||
                      receptions?.order_id != null ||
                      itemsVouchers.length > 0
                      " small>
                      {{ item.code }}
                      <country-flag :country="getFlag(item.id)" size="small" class="ml-n2" />
                    </v-btn>
                  </v-btn-toggle>

                  <v-autocomplete v-if="
                    type != 6 &&
                    filters.business &&
                    filters.business.value &&
                    (itemsBussines.find(
                      (element) => element.id == filters.business.value
                    )?.use_ncf ||
                      itemsBussines.find(
                        (element) => element.id == filters.business.value
                      )?.use_ecf)
                  " v-model="tipComprobante" :items="allNfc" item-text="name" item-value="id" label="Tipo NCF" dense
                    outlined return-object required
                    :hint="ecfCompradorRules ? (ecfCompradorRules.noComprador ? 'Sin comprador' : ecfCompradorRules.onlyForeign ? 'Solo ID extranjero' : ecfCompradorRules.rncRequired ? 'RNC obligatorio' : ecfCompradorRules.foreignAllowed ? 'RNC, cédula o extranjero' : 'RNC o cédula') : ''"
                    persistent-hint></v-autocomplete>
                  <v-autocomplete v-if="
                    itemsBussines.find(
                      (element) => element.id == filters.business.value
                    )?.use_ecf &&
                    (type == 3 || type == 4) && noteBaseIsElectronic
                  " v-model="reason_note" :items="reason_notes" item-value="id" class="mt-4" label="Razón nota" dense
                    outlined hide-details="auto" return-object required></v-autocomplete>

                  <!-- <v-autocomplete v-if="type === 1 || type === 2" v-model="selected_invoice_categories"
                    :items="invoice_categories" item-text="name" item-value="id" label="Tipo de factura" dense outlined
                    hide-details="auto" required class="mt-4"></v-autocomplete> -->
                  <v-row align="center" justify="center">
                    <v-col md="6">
                      <v-btn v-if="manual_currency_rate == null" outlined
                        :disabled="seleted_currencies == 3 || receptions?.order_id != null" dense
                        @click="manual_currency_rate = rate_info.value" color="primary">Establecer tasa
                      </v-btn>
                      <v-text-field v-else label="Tasa" v-model="manual_currency_rate" outlined type="number" dense
                        @change="update_manual_currency_rate()" hide-details>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="4">
              <v-card outlined class="mb-4">
                <v-card-title class="subtitle-1">
                  <v-icon left color="primary">mdi-calendar</v-icon>
                  Fechas
                </v-card-title>
                <v-card-text>
                  <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="date" label="Fecha" prepend-inner-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" dense outlined hide-details="auto"
                        :rules="[(v) => !!v || 'Fecha es requerido']"></v-text-field>
                    </template>
                    <v-date-picker v-model="date" @input="menu = false"></v-date-picker>
                  </v-menu>
                  <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="date3" label="Fecha contable" prepend-inner-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" dense outlined hide-details="auto" class="mt-2"
                        :rules="[(v) => !!v || 'Fecha es requerido']"></v-text-field>
                    </template>
                    <v-date-picker :min="dates_accounting.start_date" :max="dates_accounting.end_date" v-model="date3"
                      @input="(menu2 = false), loadExchangeMoney()"></v-date-picker>
                  </v-menu>
                  <v-text-field v-model="date2" label="Fecha Vencimiento" prepend-inner-icon="mdi-calendar" readonly
                    dense disabled outlined hide-details="auto" class="mt-2"></v-text-field>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row class="mt-n7">
            <v-col cols="12" md="6">
              <v-card outlined
                :style="ecfEntityValidation.status === 'error'   ? 'border-color:#F44336!important' :
                        ecfEntityValidation.status === 'warning' ? 'border-color:#FF9800!important' :
                        ecfEntityValidation.status === 'ok'      ? 'border-color:#4CAF50!important' : ''">
                <v-card-title class="subtitle-1">
                  <v-icon left
                    :color="ecfEntityValidation.status === 'error'   ? 'error'   :
                            ecfEntityValidation.status === 'warning' ? 'warning' :
                            ecfEntityValidation.status === 'ok'      ? 'success' : 'primary'">
                    {{ ecfEntityValidation.status === 'error'   ? 'mdi-account-alert' :
                       ecfEntityValidation.status === 'warning' ? 'mdi-account-clock' :
                       ecfEntityValidation.status === 'ok'      ? 'mdi-account-check' : 'mdi-account' }}
                  </v-icon>
                  {{ type === 1 ? "Suplidor" : "Cliente" }}
                </v-card-title>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12" md="8">
                      <v-menu open-on-click :close-on-content-click="false" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-bind="attrs" v-on="on"
                            :value="selectedEntity != null ? selectedEntity.name : ''"
                            :label="type === 1 ? 'Suplidor' : 'Cliente'" dense @click="forche_search_entity_open = true"
                            outlined hide-details readonly :disabled="type === 3 || type === 4"
                            :rules="[(v) => !!v || 'Cliente requerido']"></v-text-field>
                        </template>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="4">
                      <searchClients :types_clients="type == 6 ? 2 : type" :location_id="filters?.location?.id"
                        :force_open="forche_search_entity_open" @selected-item="selectEntity($event)"
                        @close-dialog="forche_search_entity_open = false" />
                    </v-col>
                  </v-row>
                  <v-tooltip bottom :disabled="!ecfCompradorRules">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-bind="attrs" v-on="on"
                        :value="selectedEntity != null ? selectedEntity.document_id : ''" label="RNC o Cédula"
                        dense outlined hide-details="auto" readonly class="mt-4"></v-text-field>
                    </template>
                    <span v-if="ecfCompradorRules">
                      e-CF {{ ecfCompradorRules.code }}:
                      <span v-if="ecfCompradorRules.noComprador">sin comprador</span>
                      <span v-else-if="ecfCompradorRules.onlyForeign">solo identificador extranjero</span>
                      <span v-else-if="ecfCompradorRules.rncRequired">RNC obligatorio (9 dígitos)</span>
                      <span v-else-if="ecfCompradorRules.foreignAllowed">RNC, cédula o extranjero</span>
                      <span v-else>RNC o cédula</span>
                    </span>
                  </v-tooltip>
                  <div v-if="ecfEntityValidation.status !== 'none'" class="mt-1 d-flex align-center">
                    <v-chip
                      :color="ecfEntityValidation.status === 'error' ? 'error' : ecfEntityValidation.status === 'warning' ? 'warning' : 'success'"
                      x-small label text-color="white">
                      <v-icon x-small left>
                        {{ ecfEntityValidation.status === 'error' ? 'mdi-alert-circle' : ecfEntityValidation.status === 'warning' ? 'mdi-alert' : 'mdi-check-circle' }}
                      </v-icon>
                      {{ ecfEntityValidation.message }}
                    </v-chip>
                  </div>
                  <v-autocomplete v-if="
                    selectedEntity.entity_branches &&
                    selectedEntity.entity_branches.length != 0
                  " v-model="selectedBranche" :items="selectedEntity.entity_branches" item-text="name" item-value="id"
                    label="Sucursal" dense outlined hide-details="auto" :disabled="type === 3 || type === 4"
                    return-object class="mt-4"></v-autocomplete>
                  <v-text-field v-if="type === 1" dense prefix="#" outlined class="mt-2"
                    v-model="supplier_invoice_number" label="factura suplidor">
                  </v-text-field>

                  <v-text-field class="mt-n4" v-if="type === 1" dense prefix="#" outlined
                    v-model="supplier_voucher_edit" label="Comprobante suplidor">
                  </v-text-field>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card outlined>
                <v-card-title class="subtitle-1">
                  <v-icon left color="primary">mdi-cash-multiple</v-icon>
                  Información de Pago
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col md="12">
                      <v-autocomplete v-model="selectedCreditDays" :items="credit_days" item-text="name" item-value="id"
                        label="Plazo de pago cliente" prepend-inner-icon="mdi-credit-card-clock" dense outlined
                        hide-details="auto" :disabled="type === 3 || type === 4"></v-autocomplete>
                      <v-btn color="primary" small class="mt-2" @click="dialogAdditionalFields = true" block>
                        <v-icon left>mdi-plus</v-icon>
                        Agregar Campos Adicionales
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row v-if="type === 3">
                    <v-col md="6">
                      <v-text-field v-model="p_note_provider_number" label="Numero de nota suplidor" dense outlined
                        hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col md="6">
                      <v-text-field v-model="p_note_provider_ncf" label="NCF de nota suplidor" dense outlined
                        hide-details="auto"></v-text-field>
                    </v-col>
                  </v-row>

                  <v-switch v-if="selectedEntity.from_percent_discount > 0" v-model="hasDiscount"
                    label="Aplicar descuento" class="mt-4"></v-switch>
                  <v-autocomplete v-if="hasDiscount" v-model="discount_percent_selected" :items="defaultFilteredOptions"
                    label="Descuento por defecto" item-text="label" item-value="value" dense outlined
                    hide-details="auto" class="mt-0"></v-autocomplete>

                  <v-text-field class="mt-4" v-if="hasDiscount" v-model="discount_percent_selected" type="number"
                    :max="parseFloat(selectedEntity.to_percent_discount * 100)"
                    :min="selectedEntity.to_percent_discount" label="Porcentaje de descuento" dense></v-text-field>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-card outlined class="mt-6">
            <v-card-title class="subtitle-1 d-flex justify-space-between align-center">
              <div>
                <v-icon left color="primary">mdi-table</v-icon>
                Productos
              </div>
              <v-text-field v-model="searchProduct" append-icon="mdi-magnify" label="Buscar producto" single-line
                hide-details dense outlined class="ml-4" style="max-width: 300px"></v-text-field>
              <v-btn v-if="itemsVouchers.length == 0 && type != 3" color="primary" @click="showItems"
                class="ml-4" :disabled="disabled_add_product">
                Agregar Producto
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-data-table :headers="headers" :items="items" :search="searchProduct" :items-per-page="10" dense
                item-key="key" class="elevation-1">
                <template v-slot:[`item.item_name`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{ item.item_name }}</span>
                    </template>
                    <span>{{ item.item_name }}</span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.reference`]="{ item }">
                  <v-text-field v-model="item.reference" dense hide-details :readonly="disableInput"></v-text-field>
                </template>

                <template v-slot:[`item.type`]="{ item }">
                  <v-radio-group v-model="item.type" column>
                    <v-radio label="Cantidad" value="quantity"></v-radio>
                    <v-radio label="Precio" value="price"></v-radio>
                  </v-radio-group>
                </template>
                <template v-slot:[`item.quantity`]="{ item }">
                  <div class="d-flex flex-column" style="min-width:110px">
                    <v-text-field
                      v-model="item.quantity"
                      type="number"
                      dense
                      :hide-details="!(type === 3 && item.original_quantity)"
                      :min="0"
                      :max="type === 3 && item.original_quantity ? item.original_quantity - (item.credited_qty || 0) : undefined"
                      :rules="type === 3 && item.original_quantity
                        ? [v => parseFloat(v||0) <= (item.original_quantity - (item.credited_qty||0)) || `Máx: ${item.original_quantity - (item.credited_qty||0)}`]
                        : []"
                      :error="type === 3 && item.original_quantity != null && parseFloat(item.quantity||0) > (item.original_quantity - (item.credited_qty||0))"
                      :readonly="[3, 4].includes(type) ? false : disableInput"
                      @input="updateAmount(item)"
                    ></v-text-field>
                    <div v-if="[3,4].includes(type) && item.original_quantity != null" class="text-caption grey--text mt-n1">
                      orig: {{ item.original_quantity }}
                      <span v-if="item.credited_qty > 0" class="warning--text"> · usados: {{ item.credited_qty }}</span>
                    </div>
                  </div>
                </template>
                <template v-slot:[`item.amount`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-bind="attrs" v-on="on" v-model="item.amount" prefix="$" type="number" dense
                        hide-details :max="max_amount_per_item(item)" :min="max_amount_per_item(item) * -1"
                        :readonly="disable_change_price(item)" @input="updateAmount(item)"></v-text-field>
                    </template>
                    <span>{{
                      type == 2 && !item.editable ? "Articulo no editable" : "Puede editar"
                    }}</span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.discount`]="{ item }">
                  <v-text-field :value="currencyFormat(
                    parseFloat(item.discount) *
                    parseFloat(item.amount) *
                    parseFloat(item.quantity)
                  )
                    " dense hide-details readonly></v-text-field>
                </template>
                <template v-slot:[`item.itbis`]="{ item }">
                  <v-autocomplete v-model="item.itbis" :items="itbis" item-text="name" item-value="value" dense
                    hide-details return-object :readonly="[17, 18, 20, 21].includes(tipComprobante?.id)
                      ? true
                      : type == 1
                        ? false
                        : disableInput
                      "></v-autocomplete>
                </template>
                <template v-slot:[`item.total`]="{ item }">
                  {{ item.itbis ? getTotalAmountLine(item) : "-" }}
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon small class="mr-2" @click="edit_item(item)" v-bind="attrs" v-on="on">
                        mdi-pencil
                      </v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon small v-show="!disableInput || [3, 4].includes(type)" @click="deleteProducts(item)"
                        v-bind="attrs" v-on="on">
                        mdi-delete
                      </v-icon>
                    </template>
                    <span>Eliminar</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <PreAccounting v-if="pre_accounting_computed.length > 0 && [1, 2, 10].includes(type)" :invoice_type="type"
            :cant_edit="order_entry_id == null" :search_names="true" :order_item_entries="pre_accounting_computed"
            :totalOrderAmount="totales.tot_amount" :show_credits="false" :cuadre_in_init="true"
            :business_unit_id="filters.business.id" @set_accounts="save_acounting_invoice"
            @emit_edited_accounts="compare_accounting_edited" />
          <!-- Recepciones que se están facturando (solo cuando vienen del buscador de recepciones) -->
          <v-card v-if="selected_receptions.length" outlined class="mt-6 receptions-card">
            <v-card-title class="subtitle-1 d-flex flex-wrap align-center py-3">
              <v-icon left color="success">mdi-package-variant-closed-check</v-icon>
              Recepciones a facturar
              <v-chip x-small color="success" outlined class="ml-2">{{ selected_receptions.length }}</v-chip>
              <span class="caption grey--text text--darken-1 ml-3">
                Orden #{{ selected_receptions[0].order_id.toString().padStart(10, '0') }}
                · {{ selected_receptions[0].entity_name }}
              </span>
              <v-spacer></v-spacer>
              <span class="body-2">
                Subtotal recibido:
                <strong>{{ currencyFormat(receptionsSubtotal) }} {{ selected_receptions[0].currency_code }}</strong>
                <span class="caption grey--text ml-1">(sin ITBIS)</span>
              </span>
            </v-card-title>
            <v-divider></v-divider>
            <v-simple-table dense class="receptions-table">
              <thead>
                <tr>
                  <th>Recepción</th>
                  <th>Fecha</th>
                  <th>Factura suplidor</th>
                  <th>Ubicación</th>
                  <th>Recibido por</th>
                  <th class="text-center">Artículos</th>
                  <th class="text-right">Subtotal</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="reception in selected_receptions" :key="reception.entry_id">
                  <td>
                    <v-chip label x-small outlined color="secondary">
                      {{ reception.entry_id.toString().padStart(8, '0') }}
                    </v-chip>
                  </td>
                  <td class="text-no-wrap">{{ reception.formatted_date }}</td>
                  <td>{{ reception.supplier_invoice_number || '—' }}</td>
                  <td>{{ reception.location_description_long }}</td>
                  <td>{{ reception.user_fullname }}</td>
                  <td class="text-center">{{ (reception.order_item_entries || []).length }}</td>
                  <td class="text-right text-no-wrap font-weight-medium">
                    {{ currencyFormat(receptionSubtotal(reception)) }} {{ reception.currency_code }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
          <Footer :type="type" :disableInput="disableInput" :selected_withholdings="selected_withholdings"
            @dialogWithholdings="dialogWithholdings = true" @showDialogPayments="showDialogPayments()"
            @nota="updateNota" :discountInventory="discountInventory" :totNote="totNote" @showItems="showItems"
            @showVouchers="showsVouchers" @delete_withholdings="delete_withholdings($event)" :note="editOrCopy?.note"
            @deletePayment="deletePayment()" :selectedPayments="selectedPayments" :tipComprobante="tipComprobante"
            :totales="totales" :seleted_currencies="seleted_currencies" :currencies="currencies" class="mt-6" />

          <v-row class="mt-6 mb-6">
            <v-spacer></v-spacer>
            <v-btn @click="close" text class="mr-4">Cancelar</v-btn>
            <v-tooltip top :disabled="!noteBlockSaveReason">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-btn @click="save" color="primary" :disabled="!valid || !!noteBlockSaveReason" :loading="loading">Guardar</v-btn>
                </span>
              </template>
              <span>{{ noteBlockSaveReason }}</span>
            </v-tooltip>
            <v-spacer></v-spacer>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <!-- Additional Fields Dialog -->
    <v-dialog v-model="dialogAdditionalFields" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Campos Adicionales</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="additionalFields.content" label="CONTENT" outlined dense
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="additionalFields.color" label="COLOR" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="additionalFields.colorName" label="COLOR NAME" outlined dense
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="additionalFields.yarnLot" label="YARN LOT" outlined dense
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="additionalFields.yarnPoundAssigned" label="YARN POUND ASSIGNED (ENTIRE PIO)"
                  type="number" outlined dense hide-details @change="calculate_working_loss()"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="additionalFields.finishedPoundsOut" label="FINISHED POUNDS OUT (TOTAL PRODUCED)"
                  type="number" outlined dense hide-details @change="calculate_working_loss()"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="additionalFields.workingLoss" label="WORKING LOSS" type="number" outlined dense
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="additionalFields.customerInvoice" label="Customer Invoice" type="text" outlined
                  dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="additionalFields.servicePO" label="Service PO" type="text" outlined dense
                  hide-details></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="12">
                <v-autocomplete v-model="additionalFields.ship_to" :items="EntityShipTo" label="Ship To" dense
                  item-value="description" outlined item-text="description" hide-details required></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogAdditionalFields = false">
            Cerrar
          </v-btn>
          <v-btn color="blue darken-1" text @click="saveAdditionalFields">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogs -->
    <v-dialog v-model="dialogWithholdings" width="30%">
      <v-card>
        <v-card-title class="headline">Agregar retención al total de la factura</v-card-title>
        <v-card-text>
          <v-autocomplete v-model="selected_withholdings_push" :items="withholdings" item-text="name" item-value="id"
            label="Retenciones" outlined dense return-object></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogWithholdings = false">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="add_withholdings">Agregar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPrepaid">
      <v-card>
        <v-card-title class="headline">Agregar anticipo</v-card-title>
        <v-card-text>
          <v-container>
            <v-row v-if="prepaids.length > 0">
              <v-col cols="12" v-for="item in prepaids.filter((element) => !element.consumed)" :key="item.id">
                <v-checkbox v-model="item.selected" :label="`${item.amount} ${item.currency}`"></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogPrepaid = false">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="dialogPrepaid = false">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPayments" width="60vw">
      <payments v-if="dialogPayments" @close-payments="dialogPayments = false" :amount="parseFloat(totales.tot_amount)"
        @selected-payments="selectPayment" />
    </v-dialog>

    <v-dialog v-model="dialogItems" fullscreen hide-overlay transition="dialog-bottom-transition">
      <articles_catalogue v-if="dialogItems && refresArticles && filters.business" :type="type"
        :removeItemSelected="false" :itbis="itbis" :selected_currencies="seleted_currencies"
        :only_mfnr_item="order_entry_id != null" @selected-item="addItem" :data="{
          location: filters.location.id,
          business: filters.business.id,
          warehouse: filters.warehouse_id,
          catalogue: filters.location.catalogue_id,
        }" @close-item="dialogItems = false" />
    </v-dialog>

    <VoucherDialog v-model="dialogVouchers" :currencies="currencies" :seleted_currencies="seleted_currencies"
      :itemsVouchers="itemsVouchers" :filters="filters" :loadingVouchers="loadingVouchers"
      @clear-input-vouchers="clearInputVouchers" @load-vouchers="loadVouchers" @search-clients="searchClients"
      @fetch-vouchers="fetchVouchers" />

    <v-dialog v-model="dialogArticleAccount" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialogArticleAccount = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Ajuste de Artículo</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <ArticleAccount v-if="dialogArticleAccount" :locations="filters.business != null
            ? itemsLocations.filter(
              (element) => element.bus_id == filters.business.value
            )
            : []
            " :seleted_currencies="seleted_currencies" :type="type" :currency_rate_selected="currency_rate"
            :selected_locations="filters.location" :hasDiscount="hasDiscount"
            :discount_percent_selected="discount_percent_selected" :item="selectedArticleAccount"
            @accountable="updateItemAccountStatus" @delete="deleteItem" @close="dialogArticleAccount = false"
            @saveAccount="updateItemAccount" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_edit_item" width="500px">
      <v-card>
        <v-toolbar color="primary" dark dense flat>
          <v-toolbar-title class="subtitle-1 font-weight-bold">
            <v-icon left>mdi-pencil</v-icon>
            Edición de Artículo
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog_edit_item = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pt-6">
          <v-row dense>
            <v-col cols="12">
              <v-text-field v-model="item_to_edit.description" label="Descripción del artículo" outlined dense
                prepend-inner-icon="mdi-format-text" hide-details="auto" class="mb-4"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="item_to_edit.note" label="Nota / Comentario" outlined dense rows="6"
                prepend-inner-icon="mdi-note-text" hide-details="auto" class="mb-4"></v-textarea>
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete v-model="item_to_edit.withholding" :items="withholdings" item-text="name" item-value="id"
                label="Retención" outlined dense prepend-inner-icon="mdi-percent" hide-details="auto"
                return-object></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field :value="item_to_edit.amount * parseFloat(item_to_edit?.withholding?.percent || 0)"
                :label="'Monto a retener'" outlined dense hide-details="auto" readonly prefix="$"
                background-color="grey lighten-4"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_edit_item = false">Cancelar</v-btn>
          <v-btn color="primary" @click="save_edit_item()">
            <v-icon left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DialogConfirm :showDialog="showDialogConfirm" :confirm_settings="{
      title: 'Tiene cambios sin guardar en la contabilidad',
      btn_affirmative: 'Continuar',
      btn_negative: 'Volver',
      icon: 'mdi-alert-circle',
      size: '45%',
    }" @closeDialog="confirm_save"></DialogConfirm>
  </v-container>
</template>
<script>
import DialogConfirm from "@/components/DialogConfirm.vue";
import moment from "moment";
import searchClients from "./SearchClientOrSupplier.vue";
import SearchInvoice from "./SearchInvoice.vue";
import payments from "./Payments.vue";
import articles_catalogue from "../Inventory/ArticlesWarehouse2.vue";
import PreAccounting from "@/components/Accounting/PreAccounting.vue";
import SearchReceptions from "@/components/Shop/SearchReceptions.vue";
import ArticleAccount from "./ArticleAccount.vue";
import Footer from "./Footer.vue";
import VoucherDialog from "./VoucherDialog.vue";
import { processECF } from "@/helpers";
export default {
  components: {
    VoucherDialog,
    Footer,
    searchClients,
    payments,
    articles_catalogue,
    SearchReceptions,
    PreAccounting,
    SearchInvoice,
    ArticleAccount,
    DialogConfirm
  },
  data: () => ({
    valid: true,
    selectedVouchers: [],
    systeem_items: [2, 1],
    business_unit_parameters: null,
    prepaids: [],
    amount_prepaid: 0,
    totNote: null,
    dialogPrepaid: false,
    dates_accounting: {
      start_date: "",
      end_date: "",
    },
    showDialogConfirm: false,
    hasDiscount: false,
    page: 1,
    tipVoucher: 0,
    pageCount: 0,
    loading: false,
    in_invoice_id: null,
    discountInventory: true,
    invoice_number: "",
    selectedBranchVoucher: null,
    dialogSearchInvoice: false,
    date: moment().format("YYYY-MM-DD"),
    date2: moment().startOf("month").format("YYYY-MM-DD"),
    date3: moment().format("YYYY-MM-DD"),
    request_id: null,
    currency_rate: 0,
    manual_currency_rate: null,
    tab: null,
    discount_percent_selected: null,
    searchVouchers: "",
    percentageOptions: Array.from({ length: 100 }, (_, i) => ({
      label: `${i + 1}%`,
      value: i + 1,
    })),
    itemsVouchers: [],
    headersVouchers: [
      { text: "Factura", value: "invoice_number" },
      { text: "Sucursal", value: "location_description" },
      { text: "Cliente", value: "responsable_entity_name" },
      { text: "Fecha", value: "emission_date" },
      { text: "Total", value: "total_amount", align: "end" },
    ],
    headers_account: [
      { text: "Cuenta contable", value: "chart_of_account_id", width: "16%" },
      { text: "Categoria dgii", value: "categoryDgii", width: "12%" },
      { text: "Descripcion", value: "descripcion" },
      { text: "Departamento", value: "department_id", width: "12%" },
      { text: "Categoria", value: "diary_book_project_id", width: "12%" },
      { text: "Debito", value: "debito", width: "15%" },
      { text: "Cr", value: "cr", width: "15%" },
      { text: "Actions", value: "actions", width: "5%" },
    ],
    categoryDgii: [],
    dateSearchVouchers: moment().format("YYYY-MM-DD"),
    menuVouchers: false,
    clientBranches: null,
    selectedBranche: null,
    reason_note: null,
    dialogCb: false,
    supplier_voucher_edit: "",
    receptions: null,
    selected_receptions: [],
    order_id: null,
    invoice_parent_id: null,
    invoice_parent_ncf: null,
    supplier_invoice_number: "",
    order_entry_id: null,
    refresArticles: true,
    selectedCreditDays: null,
    p_note_provider_number: null,
    p_note_provider_ncf: null,
    dialogWithholdings: false,
    dialogSearchReceipt: false,
    selectedArticleAccount: null,
    tipBonos: false,
    selected_withholdings_push: null,
    selectedCaja: null,
    tipComprobante: null,
    pre_accounting: [],
    dialogVouchers: false,
    dialogAdditionalFields: false,
    additionalFields: {
      content: "",
      color: "",
      colorName: "",
      yarnLot: "",
      yarnPoundAssigned: 0,
      finishedPoundsOut: 0,
      workingLoss: 0,
      servicesPo: "",
      customerInvoiceNumber: "",
      ship_to: null
    },
    searchProduct: "",
    menu: false,
    menu2: false,
    menu3: false,
    loadData: false,
    loadingVouchers: false,
    loadingSaving: false,
    loadDataRequest: false,
    dialogPayments: false,
    dialogArticleAccount: false,
    dialogSearch: false,
    dialogItems: false,
    forche_search_entity_open: false,
    reason_notes: [
      { text: "Anula el NCF modificado",                   value: "1" },
      { text: "Corrige texto del NCF modificado",           value: "2" },
      { text: "Corrige montos del NCF modificado",          value: "3" },
      { text: "Reemplazo NCF emitido en contingencia",      value: "4" },
      { text: "Referencia Factura de Consumo Electrónica",  value: "5" },
      { text: "Corrige errores en valores del NCF",         value: "6" },
    ],
    selectedEntity: {
      entity_id: null,
      document_id: null,
      entity_name: null,
      business_unit_id: null,
    },
    dateAccount: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    disableInput: false,
    showArticleAccounts: true,
    loadingApp: false,
    personApplicant: "",
    commentText: "",
    itemRequest: [],
    currencies: [],
    seleted_currencies: null,
    itemsBussines: [],
    itemsLocations2: [],
    locationImage: null,
    selected_withholdings: [],
    selected_invoice_categories: null,
    itemsRoutes: [],
    editedItem: [],
    nota: "",
    items: [],
    selectedClientVoucher: null,
    clients: [],
    search: null,
    item_to_edit: {
      item_id: null,
      description: null,
      note: null,
    },
    dialog_edit_item: false,
    isLoading: false,
    itemsWarehouse: [],
    selectedPayments: [],
    catalogue_id: null,
    editedIndex: -1,
    filters: {
      business: null,
      location: null,
      department_id: null,
      warehouse_id: null,
    },
    listEditItem: [],
    listProducts: [],
    headerlistEditItem: [],
    selected_invoices: [],
    dataLocations: [],
    commentHeader: "",
    pre_accounting_saved: [],
    unsaved_changes: false
  }),
  mounted() {
    // this.clear();
    this.$nextTick(() => {
      this.getData();
    });
  },

  watch: {
    // dateSearchVouchers: {
    //   handler: async function(val) {
    //     if (this.tipVoucher != 0) {
    //       await this.fetchVouchers();
    //     }
    //   },
    // },
    tipComprobante: {
      handler(newVal) {
        if (newVal && [17, 18, 20, 21].includes(newVal.id)) {
          // Encontrar el objeto ITBIS con ID 1 (sin ITBIS)
          const sinItbis = this.itbis.find((tax) => tax.id === 1);

          // Actualizar todos los items para que teng an ITBIS con ID 1
          this.items.forEach((item) => {
            item.itbis = sinItbis;
          });
        } else {
          this.items.forEach((item) => {
            item.itbis = item.default_itbis;
          });
        }
      },
      deep: true,
    },
    seleted_currencies: {
      handler: async function (newVal, oldVal) {
        if (this.editOrCopyStatus) return;

        this.showArticleAccounts = false;
        this.updateCurrencyRate();
        await this.updateItemAmounts();
        this.showArticleAccounts = true;
      },
    },
    discount_percent_selected(val) {
      this.items.forEach((item) => {
        item.discount = parseFloat(val) / 100;
      });
    },
    hasDiscount(val) {
      if (val === true) {
        this.items.forEach((item) => {
          item.discount = parseFloat(this.discount_percent_selected) / 100;
        });
      } else {
        this.discount_percent_selected = null;
        this.items.forEach((item) => {
          item.discount = 0;
        });
      }
    },
    date(val) {
      let result = this.credit_days.find(
        (element) => element.id == this.selectedCreditDays
      );

      if (result) {
        this.date2 = moment(this.date).add(result.days, "days").format("YYYY-MM-DD");
      }
      //
    },
    selectedCreditDays(val, newVal) {
      for (let item of this.credit_days) {
        if (item.id == val) {
          this.date2 = moment(this.date).add(item.days, "days").format("YYYY-MM-DD");
        }
      }
    },
    computedData: {
      async handler(val) {
        if (val && val.invoice_id != null) {
          this.invoice_number = val.invoice_id === 0 ? null : val.invoice_number;
          this.new_data = val.invoice_details;
          this.in_invoice_id = val.invoice_id === 0 ? null : val.invoice_id;
          this.selected_invoice_categories = val.invoice_category_id;
          this.supplier_invoice_number = val.supplier_invoice_number;
          this.supplier_voucher_edit = val.supplier_invoice_voucher;
          // this.type = val.invoice_type_id;

          await this.getEntity(val.entity_id);

          if (val.entity_branch_id) {
            this.selectedBranche = val.entity_branch_id;
          }

          this.filters.business = this.itemsBussines.find(
            (element) => element.id === val.business_unit_id
          );
          this.filters.location = this.itemsLocations.find(
            (element) => element.value === val.location_id
          );

          this.filters.department_id = this.itemsDepartments.find(
            (element) => element.value === val.department_id
          );

          if (val.invoice_type_id == 10 || val.invoice_type_id == 6) {
            this.date = moment().format("YYYY-MM-DD");
            this.date2 = moment().format("YYYY-MM-DD");
            this.date3 = moment().format("YYYY-MM-DD");
          } else {
            this.date = moment(val.emission_date).format("YYYY-MM-DD");
            this.date2 = moment(val.expire_at).format("YYYY-MM-DD");
            this.date3 = moment(val.emission_date).format("YYYY-MM-DD");
          }

          this.tipComprobante = val.ncf_invoice_id ?? { id: 0, name: "SIN COMPROBANTE" };
          this.order_entry_id = val.order_entry_id;
          this.currency_rate = val.currency_rate;
          this.seleted_currencies = val.currency_id;

          this.items = val.invoice_details.map((item) => {
            const itbisItem = this.itbis.find((element) => element.id === item.tax_id);
            if (item.invoice_chart_of_accounts == null) {
              item.invoice_chart_of_accounts = [];
            }

            const accountsEdited = item.invoice_chart_of_accounts.map((account) => ({
              chart_of_account_id: account.chart_of_account_id,
              categoryDgii: null,
              entry_type_id: account.entry_type_id,
              department_id: null,
              diary_book_category_id: null,
              diary_book_sub_category_id: null,
              amount: ((parseFloat(item.price) - parseFloat(item.price) * item.discount / 100) + item.tax_value * parseFloat(item.price)) * parseFloat(item.quantity),
            }));
            return {
              key: item.item_id + "_" + Math.random().toString(36),
              item_id: item.item_id,
              id: item.item_id,
              name: item.item_name,
              item_name: item.item_name,
              reference: "",
              amount: parseFloat(item.price),
              unit: item.unit_name,
              discount: item.discount,
              unit_id: item.unit_id,
              itbis: itbisItem,
              default_itbis: itbisItem,
              quantity: item.quantity ?? 1,
              cost: item.cost,
              quantity_return: 0,
              total: item.price,
              item_chart_of_account_id: item.item_chart_of_account_id,
              accountable: false,
              accounts_edited: accountsEdited,
              order_chart_of_accounts: [accountsEdited.find((element) => element.entry_type_id == ([2, 3, 6, 10].includes(this.type) ? 2 : 1))],//si es de venta toma la cuenta credito
              warehouse_id: item.warehouse_id == undefined ? null : item.warehouse_id,
              actions: "",
            };
          });
        }
      },
      immediate: true,
    },
  },
  props: {
    accounts: {
      type: Array,
    },
    type_invoice: {
      type: Number,
    },
    salesOrShop: {
      type: Number,
    },
    editOrCopyStatus: {
      type: Boolean,
    },
    itbis: {
      type: Array,
    },
    credit_days: {
      type: Array,
    },
    ncfTypes: {
      type: Array,
    },
    invoice_categories: {
      type: Array,
    },
    withholdings: {
      type: Array,
    },
    boxes: {
      type: Array,
    },
    type: {
      type: Number,
    },
    itemsDepartments: {
      type: Array,
    },
    editOrCopy: {
      type: Object,
    },
    itemsLocations: {
      type: Array,
    },
    quotation_id: {
      type: Number,
    },
  },
  computed: {
    // La unidad de negocio emite comprobantes fiscales (NCF o eCF). Las unidades
    // que no son dominicanas (ej. SIPE EKONOMIK, Haiti) no llevan comprobante:
    // ahi el tipo no se pide y la factura/nota se guarda sin NCF (documento interno).
    businessUsesVoucher() {
      const business_unit = this.itemsBussines.find(
        (element) => element.id == this.filters.business?.value
      );
      return !!(business_unit?.use_ncf || business_unit?.use_ecf);
    },
    receptionsSubtotal() {
      return this.selected_receptions.reduce((sum, reception) => sum + this.receptionSubtotal(reception), 0);
    },
   disabled_add_product() {
        const hasBothItems = this.systeem_items.every(id =>this.items.some(item => item.id === id));
        // Si viene de una orden y NO tiene ambos items, permitir agregar
        if (this.order_entry_id && !hasBothItems) {
          return false;
        }
        return this.disableInput;
      },
    pre_accounting_computed() {
      if (this.disableInput && this.order_entry_id == null) {
        return []
      }
      let currencies_selected = { id: 0, name: "USD" };
      if (this.seleted_currencies != null) {
        currencies_selected = this.currencies.find((element) => element.id === this.seleted_currencies);
      }
      return this.items.map((item) => {
        return {
          ...item,
          currency_code: currencies_selected?.code || 'USD',
          amount: ((parseFloat(item.amount) - parseFloat(item.amount) * this.discount_percent_selected / 100) + item.itbis.value * parseFloat(item.amount)) * parseFloat(item.quantity) || 0
        };
      });
    },
    filter_invoices_vouchers() {
      return this.itemsVouchers.filter(
        (invoice) =>
          (!this.selectedClientVoucher ||
            invoice.entity_id === this.selectedClientVoucher.id) &&
          (!this.selectedBranchVoucher ||
            invoice.entity_branch_id === this.selectedBranchVoucher)
      );
    },
    branchOptions() {
      const uniqueBranches = this.itemsVouchers.reduce((acc, invoice) => {
        if (!acc.some((branch) => branch.id === invoice.entity_branch_id)) {
          acc.push({
            name: invoice.entity_branch_name,
            id: invoice.entity_branch_id,
          });
        }
        return acc;
      }, []);

      return [{ name: "Todas", id: 0 }, ...uniqueBranches];
    },
    clientsVouchers() {
      const uniqueClients = this.itemsVouchers.reduce((acc, invoice) => {
        if (!acc.some((client) => client.id === invoice.entity_id)) {
          acc.push({
            name: invoice.entity_name,
            id: invoice.entity_id,
          });
        }
        return acc;
      }, []);

      return [{ name: "Todas", id: 0 }, ...uniqueClients];
    },
    dateFormatDMY() {
      return moment(this.dateSearchVouchers).format("DD/MM/YYYY");
    },
    defaultFilteredOptions() {
      if (this.selectedEntity.from_percent_discount > 0) {
        this.discount_percent_selected = parseFloat(
          this.getAfterDot(this.selectedEntity.default_percent)
        );
        return this.percentageOptions.filter(
          (option) =>
            option.value >=
            parseFloat(this.getAfterDot(this.selectedEntity.from_percent_discount)) &&
            option.value <=
            parseFloat(this.getAfterDot(this.selectedEntity.to_percent_discount))
        );
      }
      return [];
    },
    computedData() {
      return this.editOrCopy;
    },
    currency_rate_selected() {
      return parseFloat(this.currency_rate);
    },
    headers() {
      let data = [
        { text: "ID", value: "id", width: "3%", align: "start", active: true },
        {
          text: "Producto/servicio",
          align: "start",
          sortable: false,
          width: "20%",
          value: "item_name",
          active: true,
        },
        { text: "Unidad", value: "unit", align: "start", active: true },
        { text: "Tipo", value: "type", align: "start", active: false },
        {
          text: "Impuesto",
          value: "itbis",
          width: "10%",
          align: "start",
          active: true,
        },
        { text: "Desc", value: "discount", width: "10%", align: "start", active: true },
        {
          text: "Cantidad",
          value: "quantity",
          width: "10%",
          align: "start",
          active: true,
        },
        { text: "Precio", value: "amount", width: "15%", align: "start", active: true },
        {
          text: "Cantidad a devolver",
          value: "quantity_return",
          align: "d-none",
          active: false,
        },
        { text: "Total", value: "total", align: "start", active: true },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          align: "start",
          active: true,
        },
      ];

      // Lógica para mostrar u ocultar columnas basadas en el tipo
      if (this.type === 3 || this.type === 4) {
        data[2].active = false;
        data[3].active = true;
        data[4].active = false;
        data[5].active = false;
        data[9].align = "start"; // Modifica la alineación de la columna "Total"
        data[9].active = true; // Asegura que la columna "Total" esté visible
      }

      if (this.type === 1) {
        data[4].active = false; // Oculta la columna "Tipo" para el tipo 1
      }
      return data.filter((item) => item.active);
    },
    formTitle() {
      if (this.type === 10) {
        return "Convertir en factura";
      }
      let title = "Editar ";
      if (this.in_invoice_id == null) {
        title = "Nueva ";
      }
      if (this.type === 2) {
        return title + "factura venta";
      }
      if (this.type === 1) {
        return title + "factura compra";
      }
      if (this.type === 3) {
        return title + "nota credito";
      }
      if (this.type === 4) {
        return title + "nota debito";
      }
      if (this.type === 6) {
        return title + "Cotizacion";
      }

    },
    totCont() {
      let totalCredito = 0;
      let totalDebito = 0;
      if (
        this.items[this.editedIndex].accountable === true &&
        this.items[this.editedIndex].accounts_edited.length > 0
      ) {
        this.items[this.editedIndex].accounts_edited.map(function (objeto) {
          let debito = parseFloat(objeto.debito || 0);
          let credito = parseFloat(objeto.credito || 0);
          totalDebito += debito; // Acumular el valor de débito
          totalCredito += credito; // Acumular el valor de crédito
          return { debito, credito };
        });
      }
      return { totalDebito, totalCredito };
    },
    totales() {
      let tot_itbis = 0;
      let total_amount = 0;
      let tot_subtotal = 0;
      let tot_discount = 0;
      let total_withholding = 0;
      let currencies_selected = 0;

      if (this.items.length) {
        this.items.forEach((item) => {
          if (item.amount != 0) {
            // Asegurarse de que todos los valores sean números
            const quantity = parseFloat(item.quantity) || 1;
            const amount = parseFloat(item.amount) || 0;
            const discount = parseFloat(item.discount) || 0;
            // Calculate base amount for the item
            const itemQuantityAmount = amount * quantity;
            tot_subtotal += itemQuantityAmount;
            // Calculate discount for the item
            const itemDiscount = discount * itemQuantityAmount;
            tot_discount += itemDiscount;
            // Add to total amount without ITBIS
            const itemAfterDiscount = itemQuantityAmount - itemDiscount;
            total_amount += itemAfterDiscount;
            // Calcular el ITBIS para cada artículo
            if (item.itbis && typeof item.itbis.value !== "undefined") {
              const itbisValue = parseFloat(item.itbis.value) || 0;
              const itbisAmount = itemAfterDiscount * itbisValue;
              tot_itbis += itbisAmount;
            }
            if (item.withholding_id != null) {
              const withholding = this.withholdings.find((element) => element.id == item.withholding_id);
              item.withholding_amount = this.getSubTotalAmountLine(item) * parseFloat(withholding.percent)
              total_withholding += parseFloat(item.withholding_amount || 0)
            }
          }
        });
      }

      // Handle currency selection
      if (this.seleted_currencies != null) {
        currencies_selected = this.currencies.find(
          (element) => element.id === this.seleted_currencies
        );
      }

      // Asegurarse de que tot_itbis sea un número válido
      tot_itbis = isNaN(tot_itbis) ? 0 : tot_itbis;
      return {
        tot_currency: currencies_selected,
        tot_itbis: tot_itbis.toFixed(2),
        tot_amount: total_amount + tot_itbis, // Incluir el ITBIS en el total
        tot_sub: this.currencyFormat(tot_subtotal),
        total_itbis: this.currencyFormat(tot_itbis),
        discount: tot_discount.toFixed(2),
        total_amount: total_amount + tot_itbis, // También actualizar este valor
        total_sub: tot_subtotal,
        total_withholding: total_withholding
      };
    },
    allNfc() {
      const useEcf = this.filters.business?.use_ecf ?? false;

      let ids = [];

      if (useEcf) {
        if (this.type === 1) {
          ids = [16, 17, 21];
        } else if (this.type === 2) {
          ids = [12, 13, 18, 19, 20];
        } else if (this.type === 3) {
          ids = this.noteBaseIsElectronic ? [15] : [15, 4];
        } else if (this.type === 4) {
          ids = this.noteBaseIsElectronic ? [14] : [14, 3];
        } else {
          return this.ncfTypes;
        }
      } else {
        if (this.type === 1) {
          ids = [0, 5, 7];
        } else if (this.type === 2) {
          ids = [0, 2, 1, 8, 9, 10];
        } else if (this.type === 3) {
          ids = [0, 4];
        } else if (this.type === 4) {
          ids = [0, 3];
        } else {
          return this.ncfTypes;
        }
      }
      let allNcf = this.ncfTypes
        .filter((element) => ids.includes(element.id))
        .map((element) => {
          // Create a new object that keeps all original properties
          // but modifies the name property to include the code
          return {
            ...element,
            name: `(${element.code}) - ${element.name} `,
          };
        });

      if (useEcf) {
        // Para NC/ND, si la factura base no es electrónica, solo permitir Factura Interna.
        if (this.type_invoice === 2 && [3, 4].includes(this.type) && !this.noteBaseIsElectronic) {
          return [{ name: "FACTURA INTERNA", id: null }];
        }

        allNcf.unshift({ name: "FACTURA INTERNA", id: null });
      }

      return allNcf;
    },
    noteBaseVoucher() {
      if (![3, 4].includes(this.type)) return null;

      const selected = this.selected_invoices;
      if (!selected) return null;

      const voucher = selected.invoice_ncf || selected.supplier_invoice_voucher;

      return typeof voucher === "string" ? voucher.trim() : voucher;
    },
    noteBaseIsElectronic() {
      if (![3, 4].includes(this.type)) return true;

      const selected = this.selected_invoices;
      if (!selected) return false;
      
      const v = this.noteBaseVoucher;
      const isEString = v && String(v).trim().toUpperCase().startsWith("E");
      
      return selected.dgii_status === 'ACEPTADO' || isEString;
    },
    EntityShipTo() {
      if (this.selectedEntity.entity_contact_json != undefined && this.selectedEntity.entity_contact_json != null && this.selectedEntity.entity_contact_json.length > 0) {
        return this.selectedEntity.entity_contact_json.filter((element) => element.id_type === 16);
      }
      return []
    },
    rate_info() {
      let rate = {
        value: 1,
        effective_date: 'NO ENCONTRADA',
      }
      if (this.currencies.length > 0) {
        const selectedCurrency = this.currencies.find((c) => c.id === this.seleted_currencies);
        rate = selectedCurrency ? { value: selectedCurrency.value, effective_date: moment(selectedCurrency.effective_date).format("DD/MM/YYYY") } : rate;
      }
      return rate
    },
    // Rules per eCF type: what document the buyer must/can have
    ecfCompradorRulesById() {
      return {
        12: { code: '31', label: 'Crédito Fiscal',      rncRequired: true,  foreignAllowed: false, compradorRequired: true,  noComprador: false, onlyForeign: false },
        13: { code: '32', label: 'Consumo',              rncRequired: false, foreignAllowed: true,  compradorRequired: false, noComprador: false, onlyForeign: false },
        14: { code: '33', label: 'Nota de Débito',       rncRequired: false, foreignAllowed: true,  compradorRequired: false, noComprador: false, onlyForeign: false },
        15: { code: '34', label: 'Nota de Crédito',      rncRequired: false, foreignAllowed: true,  compradorRequired: false, noComprador: false, onlyForeign: false },
        16: { code: '41', label: 'Compras',              rncRequired: true,  foreignAllowed: false, compradorRequired: true,  noComprador: false, onlyForeign: false },
        17: { code: '43', label: 'Gastos Menores',       rncRequired: false, foreignAllowed: false, compradorRequired: false, noComprador: true,  onlyForeign: false },
        18: { code: '44', label: 'Regímenes Especiales', rncRequired: false, foreignAllowed: true,  compradorRequired: true,  noComprador: false, onlyForeign: false },
        19: { code: '45', label: 'Gubernamental',        rncRequired: true,  foreignAllowed: false, compradorRequired: true,  noComprador: false, onlyForeign: false },
        20: { code: '46', label: 'Exportaciones',        rncRequired: false, foreignAllowed: true,  compradorRequired: true,  noComprador: false, onlyForeign: false },
        21: { code: '47', label: 'Pagos al Exterior',    rncRequired: false, foreignAllowed: true,  compradorRequired: false, noComprador: false, onlyForeign: true  },
      };
    },
    ecfCompradorRules() {
      if (!this.tipComprobante?.id) return null;
      return this.ecfCompradorRulesById[this.tipComprobante.id] ?? null;
    },
    // Validates the selected entity's document against the active eCF type rules
    ecfEntityValidation() {
      const rules = this.ecfCompradorRules;
      if (!rules) return { valid: true, status: 'none', message: '' };

      const doc = (this.selectedEntity?.document_id || '').toString().trim().replace(/-/g, '');
      const isRnc    = doc.length === 9;
      const isCedula = doc.length === 11;
      const isForeign = !isRnc && !isCedula && doc.length > 0;
      const hasDoc = doc.length > 0;

      if (rules.noComprador) {
        return { valid: true, status: 'ok', message: `e-CF ${rules.code}: sin comprador requerido` };
      }
      if (rules.onlyForeign) {
        if (!hasDoc) return { valid: false, status: 'error', message: `e-CF ${rules.code}: identificador extranjero obligatorio` };
        if (isRnc || isCedula) return { valid: false, status: 'error', message: `e-CF ${rules.code}: debe ser identificador extranjero, no RNC/cédula` };
        return { valid: true, status: 'ok', message: `e-CF ${rules.code}: identificador extranjero válido` };
      }
      if (rules.rncRequired) {
        if (!hasDoc) return { valid: false, status: 'error', message: `e-CF ${rules.code}: RNC obligatorio` };
        if (!isRnc) return { valid: false, status: 'error', message: `e-CF ${rules.code}: debe ser RNC (9 dígitos), actual: ${doc.length} dígitos` };
        return { valid: true, status: 'ok', message: `e-CF ${rules.code}: RNC válido` };
      }
      if (!rules.foreignAllowed && isForeign) {
        return { valid: false, status: 'error', message: `e-CF ${rules.code}: no permite identificador extranjero` };
      }
      if (!hasDoc && rules.compradorRequired) {
        return { valid: false, status: 'warning', message: `e-CF ${rules.code}: comprador requerido` };
      }
      if (hasDoc) {
        return { valid: true, status: 'ok', message: `e-CF ${rules.code}: documento válido` };
      }
      return { valid: true, status: 'none', message: '' };
    },
    noteExceedsOriginal() {
      // Solo la nota de crédito no puede exceder la factura base; la de débito la aumenta.
      if (this.type !== 3) return false;
      if (!this.selected_invoices?.invoice_id) return false;
      const noteTotal     = parseFloat(this.totales?.total_amount || 0);
      const availableBase = parseFloat(
        this.selected_invoices.available_total ?? this.selected_invoices.total_amount ?? 0
      );
      return noteTotal > 0 && availableBase > 0 && noteTotal > availableBase;
    },
    noteBlockSaveReason() {
      // Block by invalid eCF buyer document
      if (this.ecfEntityValidation.status === 'error') {
        return this.ecfEntityValidation.message;
      }
      // Block NC by item quantity exceeding available (solo crédito; el débito aumenta)
      if (this.type === 3) {
        const overQty = this.items.find(item => {
          if (item.original_quantity == null) return false;
          const max = item.original_quantity - (item.credited_qty || 0);
          return parseFloat(item.quantity || 0) > max;
        });
        if (overQty) {
          const max = overQty.original_quantity - (overQty.credited_qty || 0);
          return `"${overQty.item_name}" excede el disponible (máx ${max})`;
        }
        if (this.noteExceedsOriginal) {
          const avail = parseFloat(this.selected_invoices.available_total || 0).toFixed(2);
          return `El total de la nota excede el saldo disponible (${avail})`;
        }
      }
      return null;
    },
  },

  methods: {
    // El tipo de comprobante debe existir en la lista vigente (allNfc). Los tipos
    // que la DGII ya no acepta no aparecen ahi: el v-autocomplete se ve vacio pero
    // el modelo conservaba el tipo obsoleto y se enviaba igual a la base de datos.
    voucherTypeIsAllowed(voucher_type) {
      if (voucher_type == null) return false;
      return this.allNfc.some((element) => element.id === voucher_type.id);
    },
    // Subtotal recibido de una recepción (cantidad x precio - descuento, sin ITBIS)
    receptionSubtotal(reception) {
      return (reception.order_item_entries || []).reduce((sum, line) => {
        const subtotal = parseFloat(line.quantity || 0) * parseFloat(line.price || 0);
        return sum + subtotal * (1 - parseFloat(line.discount || 0));
      }, 0);
    },
    updateCurrencyRate() {
      this.manual_currency_rate = null;
      if (this.currencies.length > 0) {
        const selectedCurrency = this.currencies.find((c) => c.id === this.seleted_currencies);
        this.currency_rate = selectedCurrency ? selectedCurrency.value : null;
      }
    },
    update_manual_currency_rate() {
      if (this.manual_currency_rate != null && this.manual_currency_rate > 0) {
        this.currency_rate = this.manual_currency_rate;
      } else {
        this.manual_currency_rate = null;
        this.updateCurrencyRate();
      }
    },
    async updateItemAmounts() {
      for (const item of this.items) {
        if (this.editOrCopyStatus) continue;

        if (this.selectedVouchers.length > 0) {
          item.amount = item.amount_base;
        } else if (this.type === 3 || this.type === 4) {
          // Mantener el monto existente
        } else {
          if (this.receptions != null) {
            // Mantener el monto existente
          } else {
            const currencyAmount = item.item_currencies.find(
              (c) => c.currency_id === this.seleted_currencies
            );
            if (currencyAmount) {
              if (this.type === 1) {
                item.amount = parseFloat(currencyAmount.cost_price);
              } else {
                const salePrice = parseFloat(currencyAmount.sale_price);
                item.amount = this.hasDiscount
                  ? salePrice - salePrice * (this.discount_percent_selected / 100)
                  : salePrice;
              }

              item.cost = parseFloat(currencyAmount.cost_price);

              if (item.accounts_edited) {
                item.accounts_edited.forEach((account) => {
                  account.amount = item.amount;
                });
              }
            }
          }
        }
      }
    },
    async searchClients(val) {
      // Clear previous timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      // Don't search if input is empty
      if (!val) {
        this.clients = [];
        return;
      }

      // Set debounce timeout
      this.searchTimeout = setTimeout(async () => {
        try {
          this.isLoading = true;
          let typ = "AND IS_CUSTOMER=true";
          const responseRequest = await this.api_Post("accounting/search_entity", {
            name: val,
            type: typ,
            location_id: this.location_id,
            all: false,
          });
          if (responseRequest.status == 200) {
            let data = await responseRequest.json();
            this.clients = data;
          }
        } catch (error) {
          console.error("Error searching clients:", error);
          this.$toast.error("Error de conexión!");
        } finally {
          this.isLoading = false;
        }
      }, 300); // 300ms debounce delay
    },

    async updatePriceCurrency(currency_invoice) {
      let data = {
        business_unit_id: this.filters.business.id,
        effective_date: this.date3,
        currency_invoice_id: currency_invoice,
        currency_to: this.seleted_currencies,
      };
      let response = await this.api_Post("accounting/currenciesByInvoice", data);
      if (response.status == 200) {
        let datas = await response.json();
        return datas;
      }
    },
    updateNota(nota) {
      this.editOrCopy.note = nota;
    },
    changeDateExpire(val) {
      this.date2 = moment(this.date).add(val, "days").format("YYYY-MM-DD");
    },
    updateAmount(item) {
      if (item.item_id === 1) {//SI ES EL ARTICULO ES AJUSTE POR DIFERENCIA DE PRECIO UTILIZA LA TOLERANCIA MAXIMA DE LA UNIDAD DE NEGOCIOS
            const total = this.items.reduce((sum, i) => {
              if (this.systeem_items.includes(i.item_id)) return sum;
              const itemTotal = (i.accounts_edited || []).reduce((acc, a) => acc + (a.amount || 0),0);
              return sum + itemTotal;
            }, 0);
            const tolerance=this.business_unit_parameters.tolerance_percentage_adjustment_price || 0.02;
            const max = total * tolerance; // 2% tolerancia
            const min = -max;

            if (item.amount > max || item.amount < min) {
              item.amount = Math.max(Math.min(item.amount, max), min).toFixed(2);
              this.$toast.warning(`La cantidad indicada no puede exceder la tolerancia de ${tolerance * 100}% correspondiente a +-${this.currencyFormat(max)}.`);
            }
          }

          item.accounts_edited.forEach((element) => {
            element.amount = parseFloat(item.amount);
          });
      // Convierte la cantidad al valor en la moneda seleccionada
      //item.amount = parseFloat(item.amount) * this.currency_rate_selected;
    },
    async fetchVouchers(fetchData) {
      this.loadingVouchers = true;
      try {
        const response = await this.api_Post("income/search_vouchers", fetchData);
        if (response.status === 200) {
          this.itemsVouchers = await response.json();
        }
      } catch (error) {
        console.error("Error fetching vouchers:", error);
        // Handle error (e.g., show an error message to the user)
      } finally {
        this.loadingVouchers = false;
      }
    },
    async clearInputVouchers() {
      this.itemsVouchers = [];
      this.selectedVouchers = [];
      // await this.fetchVouchers();
      // selectedClientVoucher = null;
    },

    updateItemAccount(item) {
      this.items.forEach((element) => {
        if (element.item_id === item.item_id) {
          element.accounts_edited = item.accounts;
          element.item_description = item.item_description;
          element.note = item.note;
        }
      });
      this.dialogArticleAccount = false;
    },
    updateItemAccountStatus(item) {
      this.items.forEach((element) => {
        if (element.item_id === item.item_id) {
          element.accountable = item.status;
        }
      });
    },
    loadVouchers(selectedVouchers, tipVoucher, comment, manual_currency_rate) {
      this.selectedVouchers = selectedVouchers;
      this.updateNota(comment);
      const getCurrencyIdFromVoucher = (voucher) => {
        if (voucher == null) return null;
        if (voucher.currency_id != null) return voucher.currency_id;
        if (voucher.currency_code != null && this.currencies?.length) {
          const found = this.currencies.find(
            (c) => String(c.code).toUpperCase() === String(voucher.currency_code).toUpperCase()
          );
          return found?.id ?? null;
        }
        return null;
      };

      const getRateToUsd = (currencyId) => {
        if (currencyId == null) return null;
        const curr = this.currencies?.find((c) => c.id === currencyId);
        const v = curr?.value;
        const n = v == null ? null : parseFloat(v);
        return Number.isFinite(n) && n > 0 ? n : null;
      };

      const convertAmount = (amount, fromCurrencyId, toCurrencyId) => {
        const a = parseFloat(amount || 0);
        if (!Number.isFinite(a)) return 0;
        if (fromCurrencyId == null || toCurrencyId == null || fromCurrencyId === toCurrencyId) return a;

        const fromRate = manual_currency_rate != null ? manual_currency_rate : getRateToUsd(fromCurrencyId);
        const toRate = getRateToUsd(toCurrencyId);
        if (fromRate == null || toRate == null) return a;

        // value = cuántas unidades de moneda = 1 USD (ej: 145 HTG = 1 USD)
        // Para convertir: primero a USD (amount / fromRate), luego a destino (* toRate)
        return (a / fromRate) * toRate;
      };

      this.items = [];

      const invoiceCurrencyId = this.seleted_currencies;
      let total = selectedVouchers.reduce((sum, v) => {
        const voucherCurrencyId = getCurrencyIdFromVoucher(v);
        return sum + convertAmount(v.total_amount, voucherCurrencyId, invoiceCurrencyId);
      }, 0);

      let accounts = [
        {
          chart_of_account_id: tipVoucher == 5 ? 643 : 642,
          account_type_id: 2,
          entry_type_id: 2,
          location_id: this.filters.location.value,
          dgii_category_id: "",
          amount: total,
        },
      ];

      const buildItemCurrenciesFromInvoiceTotal = (invoiceTotal) => {
        const base = [
          {
            currency_id: 1,
            currency_name: "PESO DOMINICANO (DOP)",
            currency_code: "DOP",
            sale_price: convertAmount(invoiceTotal, invoiceCurrencyId, 1),
            cost_price: 0,
          },
          {
            currency_id: 2,
            currency_name: "GOURDE (HTG)",
            currency_code: "HTG",
            sale_price: convertAmount(invoiceTotal, invoiceCurrencyId, 2),
            cost_price: 0,
          },
          {
            currency_id: 3,
            currency_name: "DÓLAR ESTADOUNIDENSE (USD)",
            currency_code: "USD",
            sale_price: convertAmount(invoiceTotal, invoiceCurrencyId, 3),
            cost_price: 0,
          },
        ];

        // Asegura que la moneda del invoice quede exacta sin ruido por conversion.
        const idx = base.findIndex((c) => c.currency_id === invoiceCurrencyId);
        if (idx >= 0) base[idx].sale_price = invoiceTotal;
        return base;
      };

      this.items.push({
        key: (tipVoucher == 8 ? 2290 : 2327)+"_" + Math.random().toString(36),
        item_id: tipVoucher == 8 ? 2290 : 2327,
        id: tipVoucher == 8 ? 2290 : 2327,
        item_name: tipVoucher == 8 ? "Facturacion Bono" : "Facturacion Plan De Ahorro",
        name: tipVoucher == 8 ? "Facturacion Bono" : "Facturacion Plan De Ahorro",
        accounts_edited: accounts,
        accountable: true,
        reference: "",
        amount: total,
        unit: "UNIDAD",
        discount: 0,
        item_currencies: buildItemCurrenciesFromInvoiceTotal(total),
        itbis: this.itbis[0],
        default_itbis: this.itbis[0],
        quantity: 1,
        editable: false,
        quantity_return: 0,
        total: total,
        cost: 0,
        unit_id: 38,
        order_chart_of_accounts: accounts,
        accounts_edited: accounts,
        warehouse_id: null,
        actions: "",
      });

      this.dialogVouchers = false;
    },
    groupInvoiceDetailsByItemId(invoices) {
      const groupedDetails = {};

      // Iterar sobre cada factura
      invoices.forEach((invoice) => {
        // Iterar sobre los invoice_details de cada factura

        invoice.invoice_details.forEach((detail) => {
          // Obtener el item_id del detalle
          const itemId = detail.item_id;

          detail.amount = detail.price;
          detail.amount_base = detail.price;
          detail.price = detail.price;
          detail.quantity_return = detail.quantity;
          detail.item_id = detail.item_id;
          detail.id = detail.item_id;
          detail.unit = detail.unit_name;

          detail.itbis = this.itbis.find((element) => element.id === detail.tax_id);
          detail.default_itbis = detail.itbis;
          // Verificar si ya existe una entrada para ese item_id en el objeto agrupado
          if (!groupedDetails[itemId]) {
            // Si no existe, crear una nueva entrada con el detalle actual
            groupedDetails[itemId] = { ...detail };
          } else {
            // Si ya existe, acumular el quantity
            groupedDetails[itemId].quantity += detail.quantity;
          }
        });
      });

      // Convertir el objeto en un array plano
      const allDetails = Object.values(groupedDetails);

      return allDetails;
    },
    getAfterDot(str) {
      // Encontrar el índice del primer punto en la cadena
      const dotIndex = str.indexOf(".");
      // Si hay un punto, retornar la parte después de él; de lo contrario, retornar la cadena vacía
      return dotIndex !== -1 ? str.substring(dotIndex + 1) : "";
    },
    totalPrepaid(data) {
      let selected_currency_code = [];

      if (this.currencies.length > 0) {
        this.currencies.filter((element) => element.id == this.seleted_currencies)[0]
          .code;
      }

      const totalAmount = data.reduce((total, item) => {
        const currency = item.currency;
        const amount = parseFloat(item.amount);

        if (currency === selected_currency_code) {
          // La moneda del elemento es la misma que la moneda seleccionada, no es necesario realizar conversión.
          return total + amount;
        } else if (selected_currency_code === "DOP" && currency === "USD") {
          // Convertir de USD a DOP y sumar al total en DOP

          return total + amount * this.currency_rate_selected;
        } else if (selected_currency_code === "HTG" && currency === "USD") {
          // Convertir de HTG a USD y sumar al total en DOP

          return total + amount * this.currency_rate_selected;
        } else if (selected_currency_code === "USD" && currency === "DOP") {
          // Convertir de DOP a USD y sumar al total en USD

          return (
            total + amount / this.currencies.filter((element) => element.id == 1)[0].value
          );
        } else {
          return total; // Otras monedas se ignoran
        }
      }, 0);

      return this.currencyFormat(totalAmount.toFixed(2));
    },
    calculeTot(item) {
      if (this.type === 3 || this.type === 4) {
        return item.quantity;
      } else {
        return item.quantity;
      }
    },
    /**
     * Devuelve el total de la factura en la moneda seleccionada.
/*************  ✨ Codeium Command ⭐  *************/
    /******  f93a066c-dd5b-4cbb-956b-b88562110efb  *******/
    getCurrency(data) {
      if (data.id == 1) {
        return this.currencyFormat(this.totales.total_amount / data.value);
      }
      if (data.id == 2) {
        return this.currencyFormat(this.totales.total_amount * data.value);
      }
      if (data.id == 3) {
        return this.currencyFormat(this.totales.total_amount);
      }
    },
    getTotalAmountLine(item) {
      if (this.type === 3 || this.type === 4) {
        let amount =
          parseFloat(item.amount) * parseFloat(item.quantity) +
          item.itbis.value * parseFloat(item.amount) * parseFloat(item.quantity);

        return this.currencyFormat(amount);
      } else {
        let price = parseFloat(item.amount * parseFloat(item.quantity));

        let discount_amount = parseFloat(item.discount) * parseFloat(price);

        let amount = price - discount_amount;
        let itbis_amount = item.itbis.value * parseFloat(amount);

        let tot_amount = parseFloat(amount) + parseFloat(itbis_amount);
        return this.currencyFormat(tot_amount);
      }
    },
    getSubTotalAmountLine(item) {
      let price = parseFloat(item.amount * parseFloat(item.quantity));
      let discount_amount = parseFloat(item.discount) * parseFloat(price);
      let amount = price - discount_amount;
      return parseFloat(amount);
    },
    async getEntity(id) {
      const response = await this.api_Post("accounting/search_entity_by_id", {
        id: id,
      });
      if (response.status == 200) {
        let client = await response.json();
        this.selectEntity(client[0]);
      }
    },
    async loadExchangeMoney() {//arreglar
      const resultCurrencies = await this.api_Post("accounting/currenciesBusiness", {
        business: this.filters.business.id,

        effective_date: this.date3,
      });
      this.currencies = await resultCurrencies.json();
    },
    async loadLogo() {
      //   this.items = [];

      this.refresArticles = false;

      if (
        this.filters.business == 0 ||
        this.filters.business == null ||
        this.filters.business == undefined
      ) {
        this.currencies = [];
      } else {
        this.loadExchangeMoney();
        let data = {
          business_unit: this.filters.business.id,
          module: 4,
        };
        const request = await this.api_Post("accounting/get_calendar_accounting", data);
        if (request.status == 200) {
          const data = await request.json();
          if (data.length > 0) {
            this.dates_accounting.start_date = moment(data[0].from_date).format(
              "YYYY-MM-DD"
            );
            this.dates_accounting.end_date = moment(data[0].to_date).format("YYYY-MM-DD");
          }
        }
        this.date3 = moment().format("YYYY-MM-DD");
      }

      if (this.currencies.length > 0) {
        //this.seleted_currencies = 1;
        this.currency_rate = 1;
      }

      this.refresArticles = true;
    },
    async viewReceptions(receptions) {
      this.items = [];
      this.disableInput = true;
      let businees = this.itemsBussines.filter(
        (element) => element.id === receptions[0].business_unit_id
      );
      this.filters.business = businees[0];
      let location = this.itemsLocations.filter(
        (element) => element.id === receptions[0].location_id
      );
      this.filters.location = location[0];
      this.filters.department_id =
        receptions[0].department_names != null
          ? {
            text: receptions[0].department_names[0].department_name.description,
            value: receptions[0].department_id,
          }
          : null;

      this.selectedEntity = {
        entity_id: receptions[0].entity_id,
        document_id: receptions[0].rnc,
        entity_name: receptions[0].entity_name,
        business_unit_id: null,
      };

      this.order_entry_id = receptions[0].order_id;
      this.selectedEntity.document_id = receptions[0].rnc;
      this.selectedEntity.name = receptions[0].entity_name;
      this.selectedEntity.entity_id = receptions[0].entity_id;
      this.selected_invoice_categories = this.invoice_categories[1].id;
      if (receptions.length == 1 && receptions[0].supplier_invoice_number != null) {
        this.supplier_invoice_number = receptions[0].supplier_invoice_number;
      }


      this.tipComprobante = null;

      for (let reception of receptions) {
        for (let items of reception.order_item_entries) {
          let itbis = this.itbis.filter((element) => element.id == 1);
          this.items.push({
            id: items.item_id,
            key: items.item_id + (reception.entry_id)+ Math.random().toString(36),
            order_id: reception.order_id,
            entry_id: reception.entry_id,
            item_id: items.item_id,
            item_name: items.item_name,
            name: items.item_name,
            unit: items.unit_name,
            reference: items.item_note,
            quantity: items.quantity,
            warehouse_id: items.warehouse_id,
            unit_id: items.unit_id,
            itbis: itbis[0],
            default_itbis: itbis[0],
            account: items.item_chart_of_account_id,
            item_chart_of_account_id: items.item_chart_of_account_id,
            accounts_edited: items.order_chart_of_accounts,
            order_chart_of_accounts: items.order_chart_of_accounts,
            discount: items.discount,
            amount: parseFloat(items.price),
            price: parseFloat(items.price),
          });
        }
      }
      let dataCurrencies = await this.api_Post("accounting/currenciesBusiness", {
        business: this.filters.business.id,

        effective_date: this.dateAccount,
      });
      this.currencies = await dataCurrencies.json();
      this.seleted_currencies = receptions[0].currency_id;
      this.selectedCreditDays = receptions[0].credit_day_id;
      this.updateNota(receptions[0].comment);
      this.receptions = receptions[0];
      this.selected_receptions = receptions;
    },
    /**
     * This function is called when a invoice is selected from the search dialog. It loads the
     * invoice details into the component and sets the currency of the invoice as the selected
     * currency. It also sets the business unit, location and department of the invoice as the
     * selected filter values.
     *
     * @param {Object} item - The invoice object
     */
    async viewInvoiceSelected(item) {
      this.items = [];
      this.seleted_currencies = item.currency_id;

      this.selected_invoices = item;
      this.currency_rate = 1;
      this.disableInput = true;

      this.invoice_parent_id = item.invoice_id;

      this.invoice_parent_ncf = item.invoice_ncf;
      let businees = this.itemsBussines.filter(
        (element) => element.id === item.business_unit_id
      );
      this.filters.business = businees[0];
      let location = this.itemsLocations.filter(
        (element) => element.id === item.location_id
      );

      this.filters.location = location[0];
      this.selected_invoice_categories = this.invoice_categories[1].id;

      this.selectedEntity = {
        entity_id: item.entity_id,
        document_id: item.rnc,
        entity_name: item.entity_name,
        name: item.entity_name,
        business_unit_id: null,
      };

      this.items = [];
      let it = null;
      // Para NC omitir ítems ya acreditados (available_qty = 0); la ND carga todos (aumenta la factura)
      const detailsToLoad = (this.type === 3)
        ? item.invoice_details.filter(d => parseFloat(d.available_qty ?? d.quantity) > 0)
        : item.invoice_details;
      for (let items of detailsToLoad) {
        let itbis = this.itbis.find((element) => element.id === items.tax_id);

        let acc = [];
        for (var accounts of items?.invoice_chart_of_accounts || []) {
          acc.push({
            chart_of_account_id: accounts.chart_of_account_id,
            categoryDgii: null,
            entry_type_id: accounts.entry_type_id,
            department_id: null,
            diary_book_category_id: null,
            diary_book_sub_category_id: null,
            amount: accounts.amount,
          });
        }

        this.items.push({
          key: items.item_id + Date.now() + Math.random() + items.price,
          item_id: items.item_id,
          id: items.item_id,
          name: items.item_name,
          item_name: items.item_name,
          reference: "",
          amount: items.price,
          unit: items.unit_name,
          cost: items.cost,
          discount: "",
          itbis: itbis,
          default_itbis: itbis,
          // available_qty is set by SearchInvoice (original qty - already-credited qty)
          // La ND parte de la cantidad original; la NC de la disponible.
          quantity: parseFloat(this.type === 4 ? items.quantity : (items.available_qty ?? items.quantity)),
          original_quantity: parseFloat(items.quantity),
          credited_qty: parseFloat(items.credited_qty ?? 0),
          quantity_return: 1,
          total: items.price,
          price: items.price,
          item_chart_of_account_id: items.item_chart_of_account_id,
          accountable: false,
          accounts_edited: acc,
          warehouse_id: items.warehouse_id,
          actions: "",
          discount: 0,
        });
      }

      let dataCurrencies = await this.api_Post("accounting/currenciesBusiness", {
        business: this.filters.business.id,

        effective_date: item.emission_date,
      });

      this.currencies = await dataCurrencies.json();
      this.dialogSearchInvoice = false;

      // NC de Cuentas por Pagar en unidades que emiten comprobantes: el usuario
      // debe elegir manualmente el tipo (con comprobante o documento interno), no
      // se prefija. Las unidades sin NCF/eCF no llevan comprobante y se saltan.
      // Se usa undefined (no null) para que el v-autocomplete no empareje el
      // modelo con la opción "FACTURA INTERNA" (id: null) y quede realmente vacío.
      if (this.type === 3 && this.type_invoice === 1 && this.businessUsesVoucher) {
        this.tipComprobante = undefined;
        this.reason_note = null;
      } else if ([3, 4].includes(this.type) && this.filters.business?.use_ecf && !this.noteBaseIsElectronic) {
        this.tipComprobante = { name: "FACTURA INTERNA", id: null };
        this.reason_note = null;
      }
    },
    async getData() {
      this.loadingApp = true;
      this.itemsBussines = Object.assign([], this.$store.state.auth.bussines_units);
      this.itemsBussines.unshift({ text: "SELECCIONA LA UNIDAD", value: "0" });
      let business = this.itemsBussines.filter(
        (element) => element.id == this.$store.state.app.filters.business
      )[0];

      this.filters.business = business;
      this.itemsLocations2 = this.updateCombo(
        this.itemsLocations,
        this.itemsLocations2,
        this.filters.business,
        "location"
      );

      if (!this.editOrCopyStatus) {
        let location = this.itemsLocations.find((element) => element.id === this.$store.state.app.filters.location.value);
        this.filters.location = location;
      } else {
        // this.filters.location = this.$store.state.app.filters.location;
        // let location = this.itemsLocations.filter(
        //   (element) =>
        //     element.id == this.$store.state.app.filters.location.value
        // )[0];
        // this.filters.location = location;
      }

      // La NC de Cuentas por Pagar (type_invoice === 1) de una unidad que emite
      // comprobantes no se prefija: el usuario debe seleccionarlo. Se deja en
      // undefined (no null) para que el v-autocomplete no muestre "FACTURA INTERNA"
      // (id: null) como seleccionada.
      if (this.type === 3 && this.type_invoice === 1 && this.businessUsesVoucher) {
        this.tipComprobante = undefined;
      } else if (this.type === 3) {
        if (
          this.itemsBussines.find((element) => element.id == this.filters.business.value)
            ?.use_ecf
        ) {
          this.tipComprobante = this.ncfTypes.filter((element) => element.id === 15)[0];
        } else {
          this.tipComprobante = this.ncfTypes.filter((element) => element.id === 4)[0];
        }
      }
      if (this.type === 4) {
        if (
          this.itemsBussines.find((element) => element.id == this.filters.business.value)
            ?.use_ecf
        ) {
          this.tipComprobante = this.ncfTypes.filter((element) => element.id === 14)[0];
        } else {
          this.tipComprobante = this.ncfTypes.filter((element) => element.id === 3)[0];
        }
      }
      this.loadLogo();
      this.get_business_unit_parameters();
      this.loadingApp = false;
    },
    viewArticleAccount(item) {
      this.dialogArticleAccount = false;
      this.selectedArticleAccount = null;
      this.selectedArticleAccount = item;
      this.dialogArticleAccount = true;
    },
    addItem(item) {
      if(this.systeem_items.includes(item.item_id) && this.items.find((element) => element.id == item.item_id) != undefined){
        this.$toast.warning("No se puede agregar 2 veces un item del sistema.");
         this.dialogItems = false;
        return
      }

      let itbis = this.itbis.find((element) => element.id == item.tax_type_id);

      for (let it = 0; it < this.items.length; it++) {
        if (item.item_id == this.items[it].id) {
          this.items[it].quantity++;
        }
      }

      if (this.items.find((element) => element.id == item.item_id) === undefined) {
        let acc = [];

        let sale = parseFloat(
          item.item_currencies.filter(
            (element) => element.currency_id == this.seleted_currencies
          )[0].sale_price
        );

        let cost = parseFloat(
          item.item_currencies.filter(
            (element) => element.currency_id == this.seleted_currencies
          )[0].cost_price
        );

        if (item.item_type_id == 2) {
          if (this.type == 1) {
            acc.push({
              chart_of_account_id: item.account_categories.expense_chart_of_account_id,
              dgii_category_id: null,
              entry_type_id: this.type == 1 ? 1 : 2,
              department_id: null,
              diary_book_category_id: item.account_categories.expense_category_id,
              item_currencies: item.item_currencies,
              diary_book_sub_category_id: item.account_categories.expense_subcategory_id,
              amount: parseFloat(this.type == 1 ? cost : sale),
            });
          } else {
            acc.push({
              chart_of_account_id: item.account_categories.item_chart_of_account_id,
              dgii_category_id: null,
              entry_type_id: this.type == 1 ? 1 : 2,
              department_id: null,
              diary_book_category_id: null,
              item_currencies: item.item_currencies,
              diary_book_sub_category_id: null,
              amount: parseFloat(this.type == 1 ? cost : sale),
            });
          }
        } else if (item.item_type_id == 6) {
          acc.push({
            chart_of_account_id: item.account_categories.expense_subcategory_id,
            dgii_category_id: null,
            entry_type_id: this.type == 1 ? 1 : 2,
            department_id: null,
            diary_book_category_id: null,
            item_currencies: item.item_currencies,
            diary_book_sub_category_id: null,
            amount: parseFloat(this.type == 1 ? cost : sale),
          });
        } else {
          if (this.type == 2) {
            acc.push({
              chart_of_account_id: item.account_categories.item_chart_of_account_id,
              dgii_category_id: null,
              entry_type_id: this.type == 2 ? 2 : 1,
              department_id: null,
              diary_book_category_id: null,
              item_currencies: item.item_currencies,
              diary_book_sub_category_id: null,
              amount: parseFloat(this.type == 1 ? cost : sale),
            });
          }
          acc.push({
            chart_of_account_id: item.account_categories.inventory_chart_of_account_id,
            dgii_category_id: null,
            entry_type_id: this.type == 2 ? 2 : 1,
            department_id: null,
            diary_book_category_id: item.account_categories.inventory_category_id,
            item_currencies: item.item_currencies,
            diary_book_sub_category_id: item.account_categories.inventory_subcategory_id,
            amount: parseFloat(this.type == 1 ? cost : sale),
          });
          if (this.type == 2) {
            acc.push({
              chart_of_account_id: item.account_categories.cost_chart_of_account_id,
              dgii_category_id: null,
              entry_type_id: this.type == 2 ? 1 : 2,
              department_id: null,
              diary_book_category_id: null,
              item_currencies: item.item_currencies,
              diary_book_sub_category_id: null,
              amount: parseFloat(this.type == 1 ? cost : sale),
            });
          }
        }

        let discount_amount = this.hasDiscount
          ? parseFloat(
            this.discount_percent_selected == null ? 0 : this.discount_percent_selected
          ) / 100
          : 0;

        let index = null;
        for (var i = 0; i < this.currencies.length; i++) {
          if (i == this.seleted_currencies) {
            index = this.currencies[i].id;
          }
        }
        //VISUALIZAR PRE CONTABILIDAD
        let chart_of_account = [];
        const item_discount = this.hasDiscount ? parseFloat(this.discount_percent_selected == null ? 0 : this.discount_percent_selected) / 100 : 0
        if (this.type == 1) {
          chart_of_account.push({
            chart_of_account_id: item.account_categories.buying_chart_of_account_id,
            chart_of_account_name: item.account_categories.chart_of_account_name,
            chart_of_account_code: item.account_categories.chart_of_account_code || null,
            category_id: item.account_categories.buying_category_id,
            subcategory_id: item.account_categories.buying_subcategory_id,
            department_id: 0,
            entry_type_id: 1,
            location_id: null,
            amount: parseFloat(item.price) - (parseFloat(item.price) * item_discount),
          });
          //  if(item.is_inventoriable){
          //     chart_of_account.push({
          //       chart_of_account_id: item.account_categories.inventory_chart_of_account_id,
          //       chart_of_account_name: item.account_categories.chart_of_account_name,
          //       chart_of_account_code: item.account_categories.chart_of_account_code || null,
          //       category_id: item.account_categories.inventory_category_id,
          //       subcategory_id: item.account_categories.inventory_subcategory_id,
          //       department_id: 0,
          //       entry_type_id: 2,
          //       location_id: null,
          //       amount: item.price,
          //     })
          //   }

        } else if (this.type == 2) {
          //CUENTA DE VENTA
          chart_of_account.push({
            chart_of_account_id: item.account_categories.selling_chart_of_account_id,
            chart_of_account_name: item.account_categories.chart_of_account_name,
            chart_of_account_code: item.account_categories.chart_of_account_code || null,
            category_id: item.account_categories.selling_category_id,
            subcategory_id: item.account_categories.selling_subcategory_id,
            department_id: 0,
            entry_type_id: 2,
            location_id: null,
            amount: parseFloat(item.price) - (parseFloat(item.price) * item_discount),
          })
          //SI ES INVENTARIABLE AGREGA CUENTAS DE INVENTARIO Y COSTO
          //if(item.is_inventoriable){
          //  let currencies_selected = {id:0, name: "USD"};
          //   if (this.seleted_currencies != null) {
          //     currencies_selected = this.currencies.find((element) => element.id === this.seleted_currencies);
          //   }
          //  const cost_prices = item.item_currencies.find((element) => element.currency_id === currencies_selected.id)
          //   chart_of_account.push({
          //     chart_of_account_id: item.account_categories.inventory_chart_of_account_id,
          //     chart_of_account_name: item.account_categories.chart_of_account_name,
          //     chart_of_account_code: item.account_categories.chart_of_account_code || null,
          //     category_id: item.account_categories.inventory_category_id,
          //     subcategory_id: item.account_categories.inventory_subcategory_id,
          //     department_id: 0,
          //     entry_type_id: 2,
          //     location_id: null,
          //     amount: item.price, //cost_prices?.cost_price || 0
          //   })
          // chart_of_account.push({
          //   chart_of_account_id: item.account_categories.cost_chart_of_account_id,
          //   chart_of_account_name: item.account_categories.chart_of_account_name,
          //   chart_of_account_code: item.account_categories.chart_of_account_code || null,
          //   category_id: item.account_categories.cost_category_id,
          //   subcategory_id: item.account_categories.cost_subcategory_id,
          //   department_id: 0,
          //   entry_type_id: 1,
          //   location_id: null,
          //   amount: cost_prices?.cost_price || 0
          // })              
          // }
          //CUENTA POR COBRAR
          // chart_of_account.push({
          //   chart_of_account_id: this.selectedEntity.customer_details[0].customer.account_payable_id,
          //   chart_of_account_name: item.account_categories.chart_of_account_name,
          //   chart_of_account_code: item.account_categories.chart_of_account_code || null,
          //   category_id: null,
          //   subcategory_id: null,
          //   department_id: 0,
          //   entry_type_id: 1,
          //   location_id: null,
          //   amount: item.price,
          // })
        }

        this.items.push({
          key: item.item_id,
          item_id: item.item_id,
          id: item.item_id,
          name: item.item_name,
          item_name: item.item_name,
          reference: "",
          amount: this.type == 1 ? cost : sale,
          unit: item.unit_name,
          discount: this.hasDiscount
            ? parseFloat(
              this.discount_percent_selected == null
                ? 0
                : this.discount_percent_selected
            ) / 100
            : 0,
          item_currencies: item.item_currencies,
          itbis:
            this.tipComprobante == null || this.tipComprobante.id == undefined
              ? itbis
              : this.tipComprobante.id == 17 ||
                this.tipComprobante.id == 18 ||
                this.tipComprobante.id == 20 ||
                this.tipComprobante.id == 21
                ? this.itbis.find((element) => element.id == 1)
                : itbis,
          default_itbis: itbis,
          quantity: 1,
          editable: item.editable,
          quantity_return: 0,
          total: item.price,
          cost: cost,
          unit_id: item.unit_id,
          accountable: false,
          accounts_edited: acc,
          warehouse_id:
            item.warehouse_discount != null ? item.warehouse_discount.id : null,
          actions: "",
          is_inventoriable: item.is_inventoriable,
          order_chart_of_accounts: chart_of_account
        });
      }
      //  this.pre_accounting.push({
      //     item_id: item.item_id,
      //     item_name: item.item_name,
      //     price: item.price,
      //     quantity: 1,      
      //     currency_code: 'DOP',
      //     order_chart_of_accounts: [{
      //       chart_of_account_id: item.account_categories.inventory_chart_of_account_id,
      //       chart_of_account_name: item.account_categories.chart_of_account_name,
      //       chart_of_account_code: item.account_categories.chart_of_account_code || null,
      //       category_id: item.account_categories.inventory_category_id || null,
      //       subcategory_id: item.account_categories.inventory_subcategory_id || null,
      //       department_id: 0,
      //       entry_type_id: 1,
      //       location_id: null,
      //       amount: item.price,
      //     }]
      //   })
      if (this.selected_withholdings_push != null) {
        this.add_withholdings();
      }
    },

    async showsVouchers() {
      this.itemsVouchers = [];

      // this.itemsVouchers=
      if (this.filters.business == null) {
        this.$toast.warning("Debes elegir una unidad de negocio!");
        return;
      }

      if (this.filters.location == null) {
        this.$toast.warning("Debes elegir una location!");
        return;
      }

      if (this.selectedEntity.entity_id == null) {
        this.$toast.warning("Debes elegir un cliente!");
        return;
      }

      this.dialogVouchers = true;
    },

    showItems() {
      if (this.filters.business == null) {
        this.$toast.warning("Debes elegir una unidad de negocio!");
        return;
      }

      if (this.filters.location == null) {
        this.$toast.warning("Debes elegir una location!");
        return;
      }

      // if (this.filters.location.catalogue_id == null) {
      //   this.$toast.warning("Este location /invoice_register catalogo de articulo!");
      //   return;
      // }
      if (this.selectedEntity.entity_id == null) {
        this.$toast.warning("Debes elegir un cliente!");
        return;
      }

      this.dialogItems = true;
    },
    updateCombo(itemsOrigen, itemsDestino, condicion, combo) {
      if (itemsOrigen == undefined) {
        return [];
      }
      itemsDestino.splice(0, itemsDestino.length);

      for (let item of itemsOrigen) {
        if (item.bus_id === condicion) {
          itemsDestino.push({
            value: item.value,
            text: item.text,
            routes: item.routes,
          });
        }
      }
      return itemsDestino;
    },
    showDialogPayments() {
      this.$toast.info("Temporalmente no disponible");
      //this.dialogPayments = true;
    },

    async updateWarehouse() {
      this.selectedEntity = {
        document_id: null,
        name: null,
        entity_id: null,
        entity_type_id: null,
        entity_branches: [],
      };
      this.items = [];
      this.refresArticles = false;

      const warehouses = await this.api_Get(
        "inventory/warehouseForLocation/" + this.filters.location.id
      );
      this.itemsWarehouse = await warehouses.json();

      this.filters.warehouse_id =
        this.itemsWarehouse.length == 0 ? null : this.itemsWarehouse[0].id;

      this.refresArticles = true;
    },
    add_withholdings() {
      if (this.selected_withholdings_push == null) {
        this.$toast.warning("Debes seleccionar una retención");
        return;
      }
      this.selected_withholdings = [this.selected_withholdings_push];
      this.set_general_withholding();
      this.dialogWithholdings = false;
    },
    validate() {
      return this.$refs.form.validate();
    },
    async save() {
      if (this.unsaved_changes) {
        this.showDialogConfirm = true;
        return
      }

      if (!this.validate()) {
        this.loadingSaving = false;
        return;
      }
      let currencies_selected = this.currencies.find(
        (element) => element.id == this.seleted_currencies
      );

      let payment_seletecd = [];
      const items_selected = [];

      let entity_payments = [];

      if (
        this.hasDiscount &&
        this.discount_percent_selected != null &&
        this.discount_percent_selected / 100 > this.selectedEntity.to_percent_discount
      ) {
        this.$toast.warning(
          "EL DESCUENTO SELECIONADO ES MAYOR QUE EL DESCUENTO DEL CLIENTE"
        );
        this.loadingSaving = false;
        return;
      }

      if (this.selected_invoice_categories == null) {
        this.$toast.warning("Selecciona el tipo de factura");
        this.$nextTick(this.$refs["tipFac"].focus());
        this.loadingSaving = false;
        return;
      }
      // if (this.tipComprobante == null) {
      //   if (this.type != 6) {
      //     this.$toast.warning("Selecciona el tipo de comprobante");

      //     return;
      //   }
      // }

      // NC de Cuentas por Pagar: el tipo de comprobante es obligatorio
      // (con comprobante o documento interno) solo si la unidad emite comprobantes.
      if (
        this.type === 3 &&
        this.type_invoice === 1 &&
        this.businessUsesVoucher &&
        this.tipComprobante == null
      ) {
        this.$toast.warning(
          "Selecciona el tipo de comprobante (con comprobante o documento interno)"
        );
        this.loadingSaving = false;
        return;
      }

      // Factura de compra/venta: el comprobante tiene que ser uno de los vigentes.
      // Cubre tanto el tipo por defecto obsoleto del cliente/suplidor como el que
      // se arrastra al copiar una factura vieja.
      if (
        [1, 2].includes(this.type) &&
        this.businessUsesVoucher &&
        !this.voucherTypeIsAllowed(this.tipComprobante)
      ) {
        this.$toast.warning("Selecciona el tipo de comprobante");
        this.loadingSaving = false;
        return;
      }

      if (this.items != []) {
        for (let item of this.items) {
          if (this.filters.business == null) {
            this.$toast.warning("Debes elegir una unidad de negocio !");
            this.loadingSaving = false;
            return;
          }
          if (this.filters.location == null) {
            this.$toast.warning("Debes elegir una location !");
            this.loadingSaving = false;
            return;
          }
          if (item.quantity == 0) {
            this.$toast.warning(
              "la cantidad del item " + item.name + " debe ser mayor que 0"
            );
            this.loadingSaving = false;
            return;
          }
          if (this.order_entry_id != null && [2, 1].includes(item.item_id)) {//si es de una orden y agregan el articulo mercancia facturada no recibida actualiza el monto de la contabilidad al monto digitado por el usuario
            item.order_chart_of_accounts[0].amount = item.accounts_edited[0].amount;
            item.order_chart_of_accounts[0].entry_type_id = parseFloat(item.accounts_edited[0].amount) > 0 ? 1 : 2;
          }
          // if (item.amount == 0) {
          //   this.$toast.warning(
          //     "la precio del item " + item.name + " debe ser mayor que 0"
          //   );
          //   this.loadingSaving = false;
          //   return;
          // }
          if (item.itbis == null) {
            this.$toast.warning("debes elegir un itbis para " + item.name + " ");
            this.loadingSaving = false;
            return;
          }
          let accounts = [];
          if (item.accountable) {
            if (item.accounts_edited.length > 0) {
              for (let acc of item.accounts_edited) {
                accounts.push({
                  chart_of_account_id: acc.chart_of_account_id,
                  entry_type_id: acc.entry_type_id,
                  account_type_id: acc.debito > 0 ? 1 : 2,
                  location_id: acc.location_id,
                  dgii_category_id: acc.categoryDgii,
                  department_id: acc.department_id,
                  category_id: acc.diary_book_category_id,
                  subcategory_id: acc.diary_book_sub_category_id,
                  amount: parseFloat(acc.amount),
                });
              }
            }
          }
          if (this.pre_accounting_saved.length > 0) {
            accounts = [];
            accounts = this.pre_accounting_saved.filter((element) => element.item_id == item.id);
          }

          const item_element = {
            withholding_id: item.withholding_id != undefined ? item.withholding_id : null,
            withholding_amount: item.withholding_amount ? item.withholding_amount : 0,
            item_id: item.id,
            order_entry_id: item.entry_id,
            item_description: item.item_description,
            quantity: parseFloat(this.type === 3 ? item.quantity : item.quantity),
            tax_id: item.itbis.id,
            price: item.amount,
            warehouse_id: item.warehouse_id,
            item_chart_of_account_id: item.item_chart_of_account_id,
            discount: item.discount > 0 ? item.discount : (this.hasDiscount ? parseFloat(this.discount_percent_selected) / 100 : 0),
            cost: item.cost,
            unit_id: item.unit_id,
            accounts: this.receptions != null ? item.order_chart_of_accounts.filter((element) => element.chart_of_account_id != 686) : accounts,
            note: item.note,
            is_inventoriable: item.is_inventoriable,
          };
          items_selected.push(item_element);
        }
      }
      // if (this.selected_withholdings != []) {
      //   for (let item of this.selected_withholdings) {
      //     withholding_selected.push({
      //       withholding_id: item.id,
      //     });
      //   }
      // }

      if (this.selectedPayments != []) {
        for (let item of this.selectedPayments) {
          payment_seletecd.push({
            invoice_payment_type_id: item.id,
            entity_id: this.selectedEntity.entity_id,
            payment_amount: parseFloat(item.amount),
            currency_id: currencies_selected.id,
          });
        }
      }
      let vouchers = [];

      if (this.selectedVouchers.length != 0) {
        for (let item of this.selectedVouchers) {
          vouchers.push({
            invoice_id: item.invoice_id,
          });
        }
      }

      if (this.prepaids != []) {
        for (var item of this.prepaids) {
          if (item.selected == true) {
            entity_payments.push({ entity_payment_id: item.id });
          }
        }
      }
      let settings = {
        status_order_id: null,
        metadata: this.additionalFields,
      };

      const totalPaymentAmount = payment_seletecd.reduce((total, payment) => {
        return total + payment.payment_amount;
      }, 0);

      let category = this.selected_invoice_categories;
      if (this.type == 1 || this.type == 2 || this.type == 10) {
        if (parseFloat(totalPaymentAmount) < parseFloat(this.totales.total_amount)) {
          category = 2;
        } else {
          category = 1;
        }
      }

      let type_invoice = this.type == 10 ? null : this.in_invoice_id;
      const hasPaymentTypeId6 = payment_seletecd.some(
        (payment) => payment.invoice_payment_type_id == 6
      );

      if (hasPaymentTypeId6) {
        type_invoice = 8;
        payment_seletecd = [];
      }
      let voucher = null;
      let ambiente = this.itemsBussines.find(
        (element) => element.id == this.filters.business.value
      ).ambiente;

      if (
        this.itemsBussines.find((element) => element.id == this.filters.business.value)
          .use_ncf ||
        this.itemsBussines.find((element) => element.id == this.filters.business.value)
          ?.use_ecf
      ) {
        voucher =
          this.tipComprobante != null
            ? this.tipComprobante.id == 0
              ? null
              : this.tipComprobante.id
            : null;
      }
      if (this.type == 3 || this.type == 4) {
        if (parseFloat(this.totNote) < 1) {
          this.$toast.warning("El monto deber ser mayor de 0");
          this.loadingSaving = false;
          return;
        }
        let inventory = [];

        for (let item_note of this.items) {
          if (item_note.type == null || item_note.type == undefined) {
            this.$toast.warning(
              "Debes elegir un tipo de nota para el item" + item_note.item_name
            );
            this.loadingSaving = false;
            return;
          }
          inventory.push({
            item_id: item_note.id,
            quantity: parseFloat(item_note.quantity),
            adjustment_type: item_note.type == "price" ? "PRICE" : "QUANTITY",
            adjustment_amount: item_note.amount,
          });
        }

        this.loading = true;
      }
      try {
        if (this.type == 3 || this.type == 4) {
          if (parseFloat(this.totNote) < 1) {
            this.$toast.warning("El monto deber ser mayor de 0");
            this.loadingSaving = false;
            return;
          }
          let inventory = [];

          for (let item_note of this.items) {
            if (item_note.type == null || item_note.type == undefined) {
              this.$toast.warning(
                "Debes elegir un tipo de nota para el item" + item_note.item_name
              );
              this.loadingSaving = false;
              return;
            }
            inventory.push({
              item_id: item_note.id,
              quantity: parseFloat(item_note.quantity),
              adjustment_type: item_note.type == "price" ? "PRICE" : "QUANTITY",
              adjustment_amount: item_note.amount,
              tax_id: item_note.itbis.id,
              tax_value: item_note.itbis.value,
            });
          }
    
          let data2 = {
            in_note_id: null,
            in_invoice_id: this.invoice_parent_id,
            in_note: this.type == 3 ? "CREDIT" : "DEBIT",
            in_created_by: this.$store.state.auth.user.user.user_id,
            in_reason: this.editOrCopy?.note ?? null,
            in_effective_date: this.date + " " + moment().format("HH:mm:ss"),
            in_account_date: this.date3 + " " + moment().format("HH:mm:ss"),
            in_note_details: inventory,
            p_note_provider_number: this.p_note_provider_number,
            p_note_provider_ncf: this.p_note_provider_ncf,
            generate_note_nfc: voucher == null ? false : true,
          };

          this.loading = true;

          const responseRequestNote = await this.api_Post("income/note_register", data2);

          if (responseRequestNote.status == 200) {

            let result2 = await responseRequestNote.json();
            if (process.env.NODE_ENV === "production" && result2[0].business_unit_id === 145 && [2, 3, 4].includes(this.type)) {//SI ES DK Y ES DE CXC ENVIA INTERFACE A PEOPLESOFT
              this.api_Get(`income/expoort_invoice_sales_pps/${result2[0].id}/2`);
            }

            this.$emit("save-note", result2);

            // Limpiar el comentario/nota luego de guardar la nota de crédito
            this.updateNota("");

            if (this.filters.business?.use_ecf && result2[0].note_ncf != null) {
              const resultado = await this.get_dgii_json(result2[0].invoice_note_number);

              const cabecera = {
                "Content-Type": "application/json",
                "X-API-KEY": "dev-dgii-ecf-api-key-2023",
              };

              const url = process.env.VUE_APP_API_DGII;
              const ambiente_dgii =
                process.env.NODE_ENV === "production"
                  ? process.env.VUE_APP_API_DGII_AMBIENTE
                  : process.env.VUE_APP_API_DGII_AMBIENTE_TEST;

              const request = {
                method: "POST",
                headers: cabecera,
                body: JSON.stringify(resultado),
              };
              const response2 = await fetch(
                `${url}api/${this.filters.business.ambiente}/${resultado.ECF.Encabezado.Emisor.RNCEmisor}/Invoice/create`,
                request
              );

              if (response2.status == 200) {
                let dataApiDgii = await response2.json();

                let secure_code = dataApiDgii.data.codigoSeguridad;
                const responseScureCode = await this.api_Post(
                  "income/update_secure_note_code",
                  {
                    code: secure_code,
                    id: result2[0].id,
                  }
                );
                // if (responseScureCode.status == 200) {
                // }
                // this.$toast.success("Factura creada correctamente");
              } else {
                await this.warnDgiiFailure(response2, result2[0].note_ncf);
              }
              this.loadingSaving = false;
            }
          } else {
            this.$toast.error(responseRequestNote.message);
          }
        } else {
          if (this.filters.business?.use_ecf) {
            // if(voucher==20 && this.selectedEntity.document_id_type_id!=5){
            //   this.$toast.warning(
            //     "Para el comprobante (46) el cliente debe tener un tipo de identificacion extranjero"
            //   );
            //   return;
            // }
            if (voucher == 21 && this.selected_withholdings_push == null) {
              this.$toast.warning(
                "Debes seleccionar un retencion para este tipo de comprobante"
              );
              this.loadingSaving = false;
              return;
            }

            if (voucher == 16 && this.selected_withholdings_push == null) {
              if (
                this.selected_withholdings.length == 0 ||
                this.selected_withholdings == undefined ||
                this.selected_withholdings == null
              ) {
                this.$toast.warning(
                  "Debes seleccionar un retencion para este tipo de comprobante"
                );
                this.loadingSaving = false;
                return;
              }
            }
          }

          let data = {
            in_invoice_id: this.quotation_id != null ? null : type_invoice,
            in_category_id: category,
            in_type_id: this.type == 10 ? 2 : this.type,
            in_voucher_type_id: voucher,
            in_business_unit_id: this.filters.business.value,
            in_location_id: this.filters.location.value,
            in_department_id:
              this.filters.department_id != null
                ? typeof this.filters.department_id === "object"
                  ? this.filters.department_id.value
                  : this.filters.department_id
                : null,

            in_entity_id: this.selectedEntity.entity_id,
            in_responsable_entity_id: null,
            in_entity_branch_id:
              this.editOrCopyStatus == true
                ? this.computedData.entity_branch_id
                : this.selectedBranche?.id || null,
            in_created_by: this.$store.state.auth.user.user.user_id,
            in_effective_date: this.date + " " + moment().format("HH:mm:ss"),
            in_account_date: this.date3 + " " + moment().format("HH:mm:ss"),
            in_expire_at: this.date2,
            in_currency_id: currencies_selected.id,
            in_currency_rate: 1 / this.manual_currency_rate,
            in_note: this.computedData?.note == undefined ? "" : this.computedData.note,
            in_box_entry_id: null,
            in_order_entry_id: this.order_entry_id,
            in_ncf_invoice_id:
              this.selected_invoices.invoice_id == undefined
                ? null
                : this.selected_invoices.invoice_id,
            in_discount: this.totales.discount,
            in_tip: this.type,
            in_invoice_vouchers: vouchers,
            in_payments: payment_seletecd,
            in_entity_payments: entity_payments,
            in_withholdings: [],
            in_supplier_details: {
              supplier_invoice_number: this.supplier_invoice_number == "" ? null : this.supplier_invoice_number,
              supplier_invoice_voucher: this.supplier_voucher_edit == "" ? null : this.supplier_voucher_edit,
            },
            order_id: items_selected[0].order_id,
            in_items: items_selected,
            is_bussiness: true,
            in_installments: null,
            in_quotation_id:
              this.quotation_id == undefined || this.quotation_id == null
                ? null
                : this.quotation_id,
            others_settings: settings,
          };
          const responseRequest = await this.api_Post("income/invoice_register", data);

          if (responseRequest.status == 200) {
            let result = await responseRequest.json();
            if (process.env.NODE_ENV === "production" && [145, 123, 132].includes(result[0].business_unit_id) && [2, 3].includes(this.type)) {//SI ES DK Y ES DE CXC ENVIA INTERFACE A PEOPLESOFT
              this.api_Get(`income/expoort_invoice_sales_pps/${result[0].id}/1`);
            }
            this.$emit("save-invoice", result);

            if (this.filters.business?.use_ecf && result[0].invoice_ncf != null) {
              const resultado = await this.get_dgii_json(result[0].invoice_number);

              const cabecera = {
                "Content-Type": "application/json",
                "X-API-KEY": "dev-dgii-ecf-api-key-2023",
              };

              const url = process.env.VUE_APP_API_DGII;
              const ambiente_dgii =
                process.env.NODE_ENV === "production"
                  ? process.env.VUE_APP_API_DGII_AMBIENTE
                  : process.env.VUE_APP_API_DGII_AMBIENTE_TEST;

              const request = {
                method: "POST",
                headers: cabecera,
                body: JSON.stringify(resultado),
              };
              const response = await fetch(
                `${url}api/${this.filters.business.ambiente}/${resultado.ECF.Encabezado.Emisor.RNCEmisor}/Invoice/create`,
                request
              );

              if (response.status == 200) {
                let dataApiDgii = await response.json();

                let secure_code = dataApiDgii.data.codigoSeguridad;
                const responseScureCode = await this.api_Post(
                  "income/update_secure_code",
                  {
                    code: secure_code,
                    invoice_id: result[0].invoice_number,
                  }
                );
                // if (responseScureCode.status == 200) {
                // }
                // this.$toast.success("Factura creada correctamente");
              } else {
                await this.warnDgiiFailure(response, result[0].invoice_ncf);
              }
              this.loadingSaving = false;
            }
          } else {
            let result2 = await responseRequest.json();
            this.$toast.warning(result2.message);
            this.loadingSaving = false;
          }
        }
      } catch (error) {
        this.loadingSaving = false;
        console.error(error.message);
        this.$toast.error("Error " + error.message);
      }
      this.loading = false;
      this.loadingSaving = false;
      // return
    },
    // El documento ya quedó guardado: solo se avisa que la DGII no lo recibió para reenviarlo desde su vista
    async warnDgiiFailure(response, ncf) {
      let detail = "";
      try {
        const text = await response.text();
        try {
          const body = JSON.parse(text);
          detail = body.message || body.mensaje || body.title || body.error || text;
        } catch (e) {
          detail = text;
        }
      } catch (e) {
        detail = "";
      }
      console.error(`Error enviando ${ncf} a DGII (HTTP ${response.status}):`, detail);
      this.$toast.error(
        `Documento guardado, pero la DGII no recibió el ${ncf} (HTTP ${response.status})` +
          (detail ? `: ${String(detail).slice(0, 200)}` : "") +
          ". Reenvíelo desde la vista del documento.",
        { timeout: 15000 }
      );
    },
    async consultPayments(id, business) {
      this.payments = [];
      const request = await this.api_Post("income/entity_payments", {
        filters:
          " WHERE ENTITY_PAYMENTS.ENTITY_ID=" +
          id +
          " AND ENTITY_PAYMENTS.business_unit_id=" +
          business,
      });
      if (request.status == 200) {
        const data = await request.json();
        return data;
      }
    },
    async selectEntity(item) {
      this.prepaids = [];
      this.forche_search_entity_open = false;

      this.selectedEntity = item;
      let use_nfc =
        this.filters.business &&
        this.filters.business.value &&
        this.itemsBussines.find((element) => element.id == this.filters.business.value)
          .use_ncf;

      this.selected_invoice_categories = this.invoice_categories[1].id;
      let branches = [];

      if (this.selectedEntity.entity_branches != null) {
        for (let item of this.selectedEntity.entity_branches) {
          branches.push(item.supplier);
        }
      }
      this.selectedEntity.entity_branches = branches;
      if (this.type === 1) {
        if (use_nfc) {
          // Si el tipo por defecto del suplidor ya no esta vigente se deja vacio
          // para que el usuario tenga que elegir uno de la lista actual.
          const default_voucher_type = this.ncfTypes.find(
            (element) => element.id == item.supplier_details[0].supplier.nfc_type_id
          );
          this.tipComprobante = this.voucherTypeIsAllowed(default_voucher_type)
            ? default_voucher_type
            : undefined;
        }
        this.selectedCreditDays = item.supplier_details[0].supplier.credit_day_id;
      }

      if (this.type === 2) {
        if (use_nfc) {
          // Si el tipo por defecto del cliente ya no esta vigente se deja vacio
          // para que el usuario tenga que elegir uno de la lista actual.
          const default_voucher_type = this.ncfTypes.find(
            (element) => element.id == item.customer_details[0].customer.nfc_type_id
          );
          this.tipComprobante = this.voucherTypeIsAllowed(default_voucher_type)
            ? default_voucher_type
            : undefined;
        }
        this.selectedCreditDays = item.customer_details[0].customer.credit_day_id;
      }

      for (let item of this.credit_days) {
        if (item.id == this.selectedCreditDays) {
          this.date2 = moment().add(item.days, "days").format("YYYY-MM-DD");
          this.selectedCreditDays = item.id;
        }

        //this.selectedCreditDays=this.credit_days
      }

      this.selected_withholdings = [];
      if (this.type == 1 && this.selectedEntity.supplier_details[0].supplier.withholding_id != null) {
        const withholdingExists = this.withholdings.find((element) => element.id == this.selectedEntity.supplier_details[0].supplier.withholding_id)
        if (withholdingExists) {
          this.selected_withholdings_push = withholdingExists;
          this.selected_withholdings.push(withholdingExists);
          this.set_general_withholding();
        }

      }
      // else {
      //   if (
      //     this.selectedEntity.customer_details[0].customer.withholding_id !=
      //     null
      //   ) {
      //     for (let item of this.withholdings) {
      //       if (
      //         item.id ==
      //         this.selectedEntity.customer_details[0].customer.withholding_id
      //       )
      //         this.selected_withholdings.push(item);
      //     }
      //   }
      // }
      this.seleted_currencies = this.selectedEntity.currency_id;
      const shipto = item?.entity_contact_json?.filter((element) => element.id_type === 16);
      this.additionalFields.ship_to = shipto == undefined ? null : shipto[0]?.description;
      this.dialogSearch = false;
    },
    selectPayment(item) {
      this.selectedPayments = item;
      this.dialogPayments = false;
    },
    edit_item(item) {
      this.item_to_edit = {
        ...item,
        item_id: item.item_id,
        description: item.item_name,
        note: item.note,
        amount: this.getSubTotalAmountLine(item),
        withholding_amount: 0,
        withholding: item.withholding_id ? this.withholdings.find((element) => element.id == item.withholding_id) : null,
        //   withholding_id:this.selectedEntity?.supplier_details[0]?.supplier?.withholding_id||null,
      };
      this.dialog_edit_item = true;
    },
    save_edit_item() {
      const index = this.items.findIndex((element) => element.item_id == this.item_to_edit.item_id);
      this.items[index].item_description = this.item_to_edit.description;
      this.items[index].item_name = this.item_to_edit.description;
      this.items[index].note = this.item_to_edit.note;

      const quantity_to_refresh = this.items[index].quantity;
      this.$set(this.items[index], 'quantity', 0.123);

      const withholdingId = this.item_to_edit.withholding ? this.item_to_edit.withholding.id : null;
      const withholdingPercent = this.item_to_edit.withholding ? parseFloat(this.item_to_edit.withholding.percent || 0) : 0;

      this.$set(this.items[index], 'withholding_id', withholdingId);
      this.$set(this.items[index], 'withholding_amount', this.item_to_edit.amount * withholdingPercent);
      this.$set(this.items[index], 'quantity', quantity_to_refresh);
      this.dialog_edit_item = false;
    },
    deleteProducts(item) {
      let editIndex = this.items.indexOf(item);
      //this.editedItem = Object.assign({}, item);
      this.items.splice(editIndex, 1);
    },
    delete_withholdings(item) {
      let editIndex = this.selected_withholdings.indexOf(item);
      //this.editedItem = Object.assign({}, item);
      for (let key in this.items) {
        this.items[key].withholding_id = null;
        this.$set(this.items[key], 'withholding_amount', 0);
      }
      this.selected_withholdings.splice(editIndex, 1);
    },
    deletePayment(item) {
      let editIndex = this.selectedPayments.indexOf(item);
      //this.editedItem = Object.assign({}, item);
      this.selectedPayments.splice(editIndex, 1);
    },
    clear() {
      this.in_invoice_id = null;
      this.prepaids = [];
      this.invoice_number = "";
      this.selected_invoices = [];
      this.selectedBranche = null;
      this.receptions = null;
      this.selected_receptions = [];
      this.request_id = null;
      this.tab = null;
      this.refresArticles = true;
      this.selectedCreditDays = null;
      this.dialogWithholdings = false;
      this.dialogSearchReceipt = false;
      //this.withholdings = [];
      this.selected_withholdings_push = null;
      this.selectedCaja = null;
      this.tipComprobante = null;
      this.searchProduct = "";
      this.menu = false;
      this.menu2 = false;
      this.loadData = false;
      this.loadDataRequest = false;
      this.dialogPayments = false;
      this.dialogSearch = false;
      this.dialogItems = false;
      this.selectedEntity = {
        entity_id: null,
        document_id: null,
        entity_name: null,
      };

      this.disableInput = false;
      this.personApplicant = "";
      this.commentText = "";
      this.itemRequest = [];

      this.locationImage = null;
      this.selected_withholdings = [];
      this.itemsRoutes = [];
      this.editedItem = [];
      this.nota = "";
      this.itemsWarehouse = [];
      this.selectedPayments = [];
      this.catalogue_id = null;
      this.editedIndex = -1;

      this.listEditItem = [];
      this.listProducts = [];
      this.headerlistEditItem = [];
      this.items = [];
    },
    save_acounting_invoice(accounting) {
      this.pre_accounting_saved = accounting;
      this.unsaved_changes = false;
    },
    compare_accounting_edited(accounting) {
      const iguales = JSON.stringify(accounting) === JSON.stringify(this.pre_accounting_saved);
      this.unsaved_changes = !iguales;
    },
    confirm_save(response) {
      this.unsaved_changes = !response;
      if (response) {
        this.save();
      }
      this.showDialogConfirm = false;
    },
    close() {
      //  this.clear();

      this.$emit("close-dialog");
    },
    saveAdditionalFields() {
      // Here you can handle the saving of additional fields
      // For now, we'll just close the dialog and log the data

      // You can add additional logic here to save the fields to your data model
      // For example:
      // this.invoice.additionalFields = { ...this.additionalFields };

      // Reset the form
      // this.additionalFields = {
      //   content: '',
      //   color: '',
      //   colorName: '',
      //   yarnLot: '',
      //   yarnPoundAssigned: 0,
      //   finishedPoundsOut: 0,
      //   workingLoss: 0
      // };

      // Close the dialog
      this.dialogAdditionalFields = false;

      // Show success message
      this.$toast.success("Campos adicionales guardados correctamente");
    },
    calculate_working_loss() {
      if (
        this.additionalFields.finishedPoundsOut <= 0 ||
        this.additionalFields.yarnPoundAssigned <= 0
      ) {
        return;
      }
      this.additionalFields.workingLoss = (
        (1 -
          this.additionalFields.finishedPoundsOut /
          this.additionalFields.yarnPoundAssigned) *
        100
      ).toFixed(2);
    },
    disable_change_price(item) {//desactiva edicion de precios
      //si es de una recepcion
      if (this.order_entry_id != null) {
        if (this.systeem_items.includes(item.item_id)) {//SI ES UN ITEM DEL SISTEMA PERMITE EDITAR
          return false;
        }
        return true;
      }
      if ([1, 3, 4].includes(this.type)) {
        return false;
      }
      return !item.editable//cuando se edita una factura ya hecha, no trae este dato.
    },
    set_general_withholding() {
      for (let key in this.items) {
        this.items[key].withholding_id = this.selected_withholdings_push.id;
        this.$set(this.items[key], 'withholding_amount', this.getSubTotalAmountLine(this.items[key]) * parseFloat(this.selected_withholdings_push.percent));
      }
    },
    max_amount_per_item(item){
       if (item.item_id == 1) {//SI ES EL ARTICULO ES AJUSTE POR DIFERENCIA DE PRECIO UTILIZA LA TOLERANCIA MAXIMA DE LA UNIDAD DE NEGOCIOS
          const total = this.items.filter(item => !this.systeem_items.includes(item.item_id)).reduce((sum, item) => {
                const itemTotal = (item.accounts_edited || []).reduce((acc, a) => acc + (a.amount || 0),0);
                return sum + itemTotal;
              }, 0);
            const max = total * this.business_unit_parameters.tolerance_percentage_adjustment_price || 0.02;//TOLERANCIA DEL 2%
          return max;
        }
      return this.type == 3 ? item.amount : 999999999999
    },
    async get_business_unit_parameters(){
      const request = await this.api_Get(`humanResource/business_unit_parameters/${this.filters.business.value}`);
      if(request.status==200){
        const data = await request.json();
        this.business_unit_parameters = data[0];
      }

    }
  },
};
</script>

<style scoped>
.receptions-card {
  border-color: #a5d6a7 !important;
}

.receptions-card .v-card__title {
  background: #f1f8f1;
}

.receptions-table ::v-deep th {
  white-space: nowrap;
}

.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid deeppink;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid cyan;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }

  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }

  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}

.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
}

.folded-paper:before {
  content: "";
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  position: absolute;
  top: 0;
  right: 0;
  border-width: 0 30px 30px 0;
  border-style: solid;
  border-color: rgb(74, 92, 67) #fff;
  transition: 0.3s;
  border-radius: 0 0 0 4px;
}

.box {
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.034), 0 6.7px 5.3px rgba(0, 0, 0, 0.048),
    0 12.5px 10px rgba(0, 0, 0, 0.06), 0 22.3px 17.9px rgba(0, 0, 0, 0.072),
    0 41.8px 33.4px rgba(0, 0, 0, 0.086), 0 100px 80px rgba(0, 0, 0, 0.12);
}

.folded_corner {
  position: relative;
  width: 100%;

  height: auto;
  border-radius: 5px;

  /* background: #58a; */
  background: linear-gradient(to left bottom, transparent 50%, rgba(194, 193, 193, 0.4) 0) no-repeat 100% 0 / 2em 2em,
    linear-gradient(-135deg, transparent 1.5em, rgb(255, 255, 255) 0);

  /* -webkit-filter: drop-shadow(20px 30px rgba(0, 0, 0, 0.1)); */
  /* filter: drop-shadow(20px 30px rgba(0, 0, 0, 0.1)); */
}

/* .folded_corner::before {
  content: " ";
  position: absolute;
  top: 2em;
  right: 0;
  background: linear-gradient(
      to left bottom,
      transparent 50%,
      rgba(0, 0, 0, 0.1) 0
    )
    100% 0 no-repeat;
  width: 2em;
  height: 2em;
  transform: rotate(180deg);
} */
</style>
